function Xe(i, e) {
  return { ...i, ...e };
}
class tn {
  baseURL;
  headers;
  constructor(e = {}) {
    const { baseURL: t = "", headers: n = {} } = e;
    this.baseURL = t, this.headers = n;
  }
  buildUrl(e, t) {
    const n = new URL(`${this.baseURL}${e}`);
    if (t) {
      const s = new URLSearchParams(Object.entries(t));
      n.search = `?${s.toString()}`;
    }
    return n.toString();
  }
  isValidUrl(e) {
    try {
      return new URL(e), !0;
    } catch {
      return !1;
    }
  }
  buildRequestOptions(e, t) {
    const n = {
      method: e,
      headers: t.headers || this.headers
    };
    return t.body && (n.body = t.body, n.headers["Content-Type"] = "application/json"), n;
  }
  async sendRequest(e, t) {
    if (!this.isValidUrl(e))
      return Promise.reject(new Error("Invalid URL provided"));
    const n = await fetch(e, t);
    return n.ok ? n.json() : this.handleErrorResponse(n);
  }
  async handleErrorResponse(e) {
    try {
      const t = await e.text(), { error: n } = JSON.parse(t);
      return Promise.reject(Xe(e, n));
    } catch (t) {
      return Promise.reject(Xe(e, t));
    }
  }
  async fetch(e, t, n, s) {
    const r = this.buildUrl(t, n.queryParameters), o = this.buildRequestOptions(e, n);
    return s && (o.body = JSON.stringify(s), o.headers["Content-Type"] = "application/json"), this.sendRequest(r, o);
  }
  setHeaders(e, t) {
    this.headers = t ? e : Xe(this.headers || {}, e);
  }
  async post(e, t, n = { method: "POST" }) {
    return this.fetch("POST", e, n, t);
  }
}
var L = [];
for (var Ye = 0; Ye < 256; ++Ye)
  L.push((Ye + 256).toString(16).slice(1));
function nn(i, e = 0) {
  return (L[i[e + 0]] + L[i[e + 1]] + L[i[e + 2]] + L[i[e + 3]] + "-" + L[i[e + 4]] + L[i[e + 5]] + "-" + L[i[e + 6]] + L[i[e + 7]] + "-" + L[i[e + 8]] + L[i[e + 9]] + "-" + L[i[e + 10]] + L[i[e + 11]] + L[i[e + 12]] + L[i[e + 13]] + L[i[e + 14]] + L[i[e + 15]]).toLowerCase();
}
var Ae, sn = new Uint8Array(16);
function rn() {
  if (!Ae && (Ae = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Ae))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ae(sn);
}
var on = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const vt = {
  randomUUID: on
};
function an(i, e, t) {
  if (vt.randomUUID && !i)
    return vt.randomUUID();
  i = i || {};
  var n = i.random || (i.rng || rn)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, nn(n);
}
const Ue = Symbol("_fields");
function g(i, e) {
  const t = i.constructor;
  if (t[Ue]) {
    t[Ue].add(e);
    return;
  }
  Object.defineProperty(i.constructor, Ue, {
    value: /* @__PURE__ */ new Set([e]),
    writable: !1
  });
}
function Ze(i) {
  const e = /* @__PURE__ */ new Set();
  for (; i && i !== Object; )
    i[Ue]?.forEach((t) => e.add(t)), i = Object.getPrototypeOf(i);
  return e;
}
var cn = Object.defineProperty, m = (i, e, t, n) => {
  for (var s = void 0, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = o(e, t, s) || s);
  return s && cn(e, t, s), s;
};
const pt = (i) => {
  const e = {};
  for (const t of Object.keys(i))
    i[t] && (e[t] = i[t]);
  return e;
};
function un(i) {
  return i.replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2").replace(/([a-z0-9])([A-Z])/g, "$1_$2").replace(/[-\s]+/g, "_").toLowerCase();
}
class R {
  random_user_id = "";
  event_name = "";
  app_id = "";
  platform = "";
  created_at_milli = Date.now();
  event_subtype;
  web_uuid;
  session_id;
  customer_user_id;
  app_version;
  web_hwid;
  country;
  event_value;
  native_language;
  learning_language;
  language;
  timezone;
  os_version;
  os_name;
  device_name;
  device_type;
  constructor(e) {
    this.country = e?.country?.toLowerCase(), this.event_subtype = e?.subtype || e?.event_subtype, this.random_user_id = e?.randomUserId, this.app_id = e?.appId || "web", this.app_version = e?.appVersion, this.platform = e?.platform, this.session_id = e?.sessionId, this.customer_user_id = e?.customer_user_id || e?.randomUserId, this.setUserAgentFields(e.userAgent);
  }
  // Protected helper method to set user agent fields
  setUserAgentFields(e) {
    this.language = navigator.language.split("-")[0], this.timezone = e.getTimezone(), this.os_version = e.detectOSVersion(), this.os_name = e.detectOS(), this.device_name = e.detectDeviceName(), this.device_type = e.detectDeviceType();
  }
}
m([
  g
], R.prototype, "random_user_id");
m([
  g
], R.prototype, "event_name");
m([
  g
], R.prototype, "app_id");
m([
  g
], R.prototype, "platform");
m([
  g
], R.prototype, "created_at_milli");
m([
  g
], R.prototype, "event_subtype");
m([
  g
], R.prototype, "web_uuid");
m([
  g
], R.prototype, "session_id");
m([
  g
], R.prototype, "customer_user_id");
m([
  g
], R.prototype, "app_version");
m([
  g
], R.prototype, "web_hwid");
m([
  g
], R.prototype, "country");
m([
  g
], R.prototype, "event_value");
m([
  g
], R.prototype, "native_language");
m([
  g
], R.prototype, "learning_language");
m([
  g
], R.prototype, "language");
m([
  g
], R.prototype, "timezone");
m([
  g
], R.prototype, "os_version");
m([
  g
], R.prototype, "os_name");
m([
  g
], R.prototype, "device_name");
m([
  g
], R.prototype, "device_type");
class j extends R {
  store;
  tracker;
  tracker_name;
  network_name;
  campaign_name;
  adgroup_name;
  creative_name;
  connection_type;
  adjust_tracker_id;
  user_agent;
  ip_address;
  environment;
  att_status;
  constructor(e) {
    super(e);
    const t = Object.keys(this);
    for (const n of t)
      e[n] !== void 0 && !this[n] && (this[n] = e[n]);
    this.adgroup_name = e.adgroup, this.campaign_name = e.campaign, this.creative_name = e.creative;
  }
}
m([
  g
], j.prototype, "store");
m([
  g
], j.prototype, "tracker");
m([
  g
], j.prototype, "tracker_name");
m([
  g
], j.prototype, "network_name");
m([
  g
], j.prototype, "campaign_name");
m([
  g
], j.prototype, "adgroup_name");
m([
  g
], j.prototype, "creative_name");
m([
  g
], j.prototype, "connection_type");
m([
  g
], j.prototype, "adjust_tracker_id");
m([
  g
], j.prototype, "user_agent");
m([
  g
], j.prototype, "ip_address");
m([
  g
], j.prototype, "environment");
m([
  g
], j.prototype, "att_status");
const Pe = class ut extends R {
  event_id = "";
  event;
  event_type;
  sdk_version;
  static #e = /* @__PURE__ */ new Set([
    ...Ze(R),
    ...Ze(j),
    ...Ze(ut)
  ]);
  static #t(e) {
    const t = {};
    for (const [r, o] of Object.entries(e)) {
      const f = un(r);
      this.#e.has(f) || (t[r] = o);
    }
    const n = pt(t), s = {
      browser: e.userAgent.getBrowserName().toLowerCase(),
      browser_version: e.userAgent.getBrowserVersion()
    };
    return JSON.stringify({ ...n, ...s });
  }
  constructor(e) {
    super(e), this.event_value = e.event_value || ut.#t(e), this.event_id = an();
    const t = Object.keys(this);
    for (const n of t)
      e[n] !== void 0 && !this[n] && (this[n] = e[n]);
  }
};
m([
  g
], Pe.prototype, "event_id");
m([
  g
], Pe.prototype, "event");
m([
  g
], Pe.prototype, "event_type");
m([
  g
], Pe.prototype, "sdk_version");
let ln = Pe;
async function hn(i) {
  const e = new j(i);
  return pt(e);
}
async function dn(i) {
  const e = new ln(i);
  return pt(e);
}
var fn = /* @__PURE__ */ ((i) => (i.SESSIONS = "analytics:sessions", i.EVENTS = "analytics:events", i))(fn || {}), Ne = /* @__PURE__ */ ((i) => (i.INITIAL = "initial", i.LOCATED = "located", i.ATTRIBUTED = "attributed", i))(Ne || {});
class pn {
  config;
  constructor(e) {
    this.config = e;
  }
  hasValidLocationData(e, t) {
    return !!(e && t);
  }
  logLocationWarning(e, t, n) {
    console.warn(
      "[EwaAnalytics SDK] Country or IP address is not set. Session located event not sent",
      {
        country: e,
        ip_address: t,
        context: n
      }
    );
  }
  createSessionLocatedData(e, t) {
    return {
      event_name: "session",
      event_subtype: Ne.LOCATED,
      random_user_id: this.config.globalConfig.initData.randomUserId,
      app_id: this.config.globalConfig.initData.appId || "web",
      platform: this.config.globalConfig.initData.platform || "web",
      // environment: 'sandbox', // TODO: make configurable
      country: e,
      ip_address: t
    };
  }
  createSessionStartedData() {
    return {
      event_name: "session",
      event_subtype: Ne.INITIAL,
      random_user_id: this.config.globalConfig.initData.randomUserId,
      platform: this.config.globalConfig.initData.platform || "web",
      app_id: this.config.globalConfig.initData.appId || "web"
      // environment: 'sandbox', // TODO: make configurable
    };
  }
  /**
   * Send session started event
   */
  async sendSessionStarted(e) {
    const t = this.createSessionStartedData();
    await this.config.eventTracker.trackEvent("session", t, e);
  }
  /**
   * Send session located event when SDK initializes
   */
  async sendSessionLocated(e, t, n) {
    if (!this.hasValidLocationData(e, t)) {
      this.logLocationWarning(e, t, n);
      return;
    }
    const s = this.createSessionLocatedData(e, t);
    await this.config.eventTracker.trackEvent("session", s, n);
  }
}
var _n = "2.0.2", lt = 500, yt = "user-agent", fe = "", St = "?", Me = "function", ie = "undefined", pe = "object", ht = "string", z = "browser", G = "cpu", K = "device", F = "engine", B = "os", le = "result", l = "name", a = "type", h = "vendor", d = "version", N = "architecture", Re = "major", u = "model", Ee = "console", b = "mobile", k = "tablet", A = "smarttv", $ = "wearable", Qe = "xr", Te = "embedded", ge = "inapp", _t = "brands", ae = "formFactors", bt = "fullVersionList", he = "platform", gt = "platformVersion", Ve = "bitness", se = "sec-ch-ua", bn = se + "-full-version-list", gn = se + "-arch", mn = se + "-" + Ve, wn = se + "-form-factors", vn = se + "-" + b, yn = se + "-" + u, qt = se + "-" + he, Sn = qt + "-version", Bt = [_t, bt, b, u, he, gt, N, ae, Ve], Ie = "Amazon", ce = "Apple", kt = "ASUS", Et = "BlackBerry", re = "Google", Tt = "Huawei", Ct = "Lenovo", xt = "Honor", Le = "LG", et = "Microsoft", tt = "Motorola", nt = "Nvidia", Rt = "OnePlus", it = "OPPO", me = "Samsung", Ot = "Sharp", we = "Sony", st = "Xiaomi", rt = "Zebra", Pt = "Chrome", At = "Chromium", Q = "Chromecast", kn = "Edge", ve = "Firefox", ye = "Opera", It = "Facebook", Lt = "Sogou", ue = "Mobile ", Se = " Browser", dt = "Windows", En = typeof window !== ie, M = En && window.navigator ? window.navigator : void 0, ee = M && M.userAgentData ? M.userAgentData : void 0, Tn = function(i, e) {
  var t = {}, n = e;
  if (!We(e)) {
    n = {};
    for (var s in e)
      for (var r in e[s])
        n[r] = e[s][r].concat(n[r] ? n[r] : []);
  }
  for (var o in i)
    t[o] = n[o] && n[o].length % 2 === 0 ? n[o].concat(i[o]) : i[o];
  return t;
}, $e = function(i) {
  for (var e = {}, t = 0; t < i.length; t++)
    e[i[t].toUpperCase()] = i[t];
  return e;
}, ft = function(i, e) {
  if (typeof i === pe && i.length > 0) {
    for (var t in i)
      if (J(i[t]) == J(e)) return !0;
    return !1;
  }
  return be(i) ? J(e).indexOf(J(i)) !== -1 : !1;
}, We = function(i, e) {
  for (var t in i)
    return /^(browser|cpu|device|engine|os)$/.test(t) || (e ? We(i[t]) : !1);
}, be = function(i) {
  return typeof i === ht;
}, ot = function(i) {
  if (i) {
    for (var e = [], t = _e(/\\?\"/g, i).split(","), n = 0; n < t.length; n++)
      if (t[n].indexOf(";") > -1) {
        var s = Oe(t[n]).split(";v=");
        e[n] = { brand: s[0], version: s[1] };
      } else
        e[n] = Oe(t[n]);
    return e;
  }
}, J = function(i) {
  return be(i) ? i.toLowerCase() : i;
}, at = function(i) {
  return be(i) ? _e(/[^\d\.]/g, i).split(".")[0] : void 0;
}, X = function(i) {
  for (var e in i) {
    var t = i[e];
    typeof t == pe && t.length == 2 ? this[t[0]] = t[1] : this[t] = void 0;
  }
  return this;
}, _e = function(i, e) {
  return be(e) ? e.replace(i, fe) : e;
}, ke = function(i) {
  return _e(/\\?\"/g, i);
}, Oe = function(i, e) {
  if (be(i))
    return i = _e(/^\s\s*/, i), typeof e === ie ? i : i.substring(0, lt);
}, ct = function(i, e) {
  if (!(!i || !e))
    for (var t = 0, n, s, r, o, f, c; t < e.length && !f; ) {
      var _ = e[t], v = e[t + 1];
      for (n = s = 0; n < _.length && !f && _[n]; )
        if (f = _[n++].exec(i), f)
          for (r = 0; r < v.length; r++)
            c = f[++s], o = v[r], typeof o === pe && o.length > 0 ? o.length === 2 ? typeof o[1] == Me ? this[o[0]] = o[1].call(this, c) : this[o[0]] = o[1] : o.length === 3 ? typeof o[1] === Me && !(o[1].exec && o[1].test) ? this[o[0]] = c ? o[1].call(this, c, o[2]) : void 0 : this[o[0]] = c ? c.replace(o[1], o[2]) : void 0 : o.length === 4 && (this[o[0]] = c ? o[3].call(this, c.replace(o[1], o[2])) : void 0) : this[o] = c || void 0;
      t += 2;
    }
}, te = function(i, e) {
  for (var t in e)
    if (typeof e[t] === pe && e[t].length > 0) {
      for (var n = 0; n < e[t].length; n++)
        if (ft(e[t][n], i))
          return t === St ? void 0 : t;
    } else if (ft(e[t], i))
      return t === St ? void 0 : t;
  return e.hasOwnProperty("*") ? e["*"] : i;
}, Dt = {
  ME: "4.90",
  "NT 3.11": "NT3.51",
  "NT 4.0": "NT4.0",
  2e3: "NT 5.0",
  XP: ["NT 5.1", "NT 5.2"],
  Vista: "NT 6.0",
  7: "NT 6.1",
  8: "NT 6.2",
  "8.1": "NT 6.3",
  10: ["NT 6.4", "NT 10.0"],
  RT: "ARM"
}, Ut = {
  embedded: "Automotive",
  mobile: "Mobile",
  tablet: ["Tablet", "EInk"],
  smarttv: "TV",
  wearable: "Watch",
  xr: ["VR", "XR"],
  "?": ["Desktop", "Unknown"],
  "*": void 0
}, jt = {
  browser: [
    [
      // Most common regardless engine
      /\b(?:crmo|crios)\/([\w\.]+)/i
      // Chrome for Android/iOS
    ],
    [d, [l, ue + "Chrome"]],
    [
      /edg(?:e|ios|a)?\/([\w\.]+)/i
      // Microsoft Edge
    ],
    [d, [l, "Edge"]],
    [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
      // Opera
    ],
    [l, d],
    [
      /opios[\/ ]+([\w\.]+)/i
      // Opera mini on iphone >= 8.0
    ],
    [d, [l, ye + " Mini"]],
    [
      /\bop(?:rg)?x\/([\w\.]+)/i
      // Opera GX
    ],
    [d, [l, ye + " GX"]],
    [
      /\bopr\/([\w\.]+)/i
      // Opera Webkit
    ],
    [d, [l, ye]],
    [
      // Mixed
      /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
      // Baidu
    ],
    [d, [l, "Baidu"]],
    [
      /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
      // Maxthon
    ],
    [d, [l, "Maxthon"]],
    [
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
      // Trident based
      /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
      // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer
      // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
      /(heytap|ovi|115)browser\/([\d\.]+)/i,
      // HeyTap/Ovi/115
      /(weibo)__([\d\.]+)/i
      // Weibo
    ],
    [l, d],
    [
      /quark(?:pc)?\/([-\w\.]+)/i
      // Quark
    ],
    [d, [l, "Quark"]],
    [
      /\bddg\/([\w\.]+)/i
      // DuckDuckGo
    ],
    [d, [l, "DuckDuckGo"]],
    [
      /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
      // UCBrowser
    ],
    [d, [l, "UCBrowser"]],
    [
      /microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i,
      /micromessenger\/([\w\.]+)/i
      // WeChat
    ],
    [d, [l, "WeChat"]],
    [
      /konqueror\/([\w\.]+)/i
      // Konqueror
    ],
    [d, [l, "Konqueror"]],
    [
      /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
      // IE11
    ],
    [d, [l, "IE"]],
    [
      /ya(?:search)?browser\/([\w\.]+)/i
      // Yandex
    ],
    [d, [l, "Yandex"]],
    [
      /slbrowser\/([\w\.]+)/i
      // Smart Lenovo Browser
    ],
    [d, [l, "Smart " + Ct + Se]],
    [
      /(avast|avg)\/([\w\.]+)/i
      // Avast/AVG Secure Browser
    ],
    [[l, /(.+)/, "$1 Secure" + Se], d],
    [
      /\bfocus\/([\w\.]+)/i
      // Firefox Focus
    ],
    [d, [l, ve + " Focus"]],
    [
      /\bopt\/([\w\.]+)/i
      // Opera Touch
    ],
    [d, [l, ye + " Touch"]],
    [
      /coc_coc\w+\/([\w\.]+)/i
      // Coc Coc Browser
    ],
    [d, [l, "Coc Coc"]],
    [
      /dolfin\/([\w\.]+)/i
      // Dolphin
    ],
    [d, [l, "Dolphin"]],
    [
      /coast\/([\w\.]+)/i
      // Opera Coast
    ],
    [d, [l, ye + " Coast"]],
    [
      /miuibrowser\/([\w\.]+)/i
      // MIUI Browser
    ],
    [d, [l, "MIUI" + Se]],
    [
      /fxios\/([\w\.-]+)/i
      // Firefox for iOS
    ],
    [d, [l, ue + ve]],
    [
      /\bqihoobrowser\/?([\w\.]*)/i
      // 360
    ],
    [d, [l, "360"]],
    [
      /\b(qq)\/([\w\.]+)/i
      // QQ
    ],
    [[l, /(.+)/, "$1Browser"], d],
    [
      /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
    ],
    [[l, /(.+)/, "$1" + Se], d],
    [
      // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
      /samsungbrowser\/([\w\.]+)/i
      // Samsung Internet
    ],
    [d, [l, me + " Internet"]],
    [
      /metasr[\/ ]?([\d\.]+)/i
      // Sogou Explorer
    ],
    [d, [l, Lt + " Explorer"]],
    [
      /(sogou)mo\w+\/([\d\.]+)/i
      // Sogou Mobile
    ],
    [[l, Lt + " Mobile"], d],
    [
      /(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
      // QQ/2345
    ],
    [l, d],
    [
      /(lbbrowser|rekonq)/i
      // LieBao Browser/Rekonq
    ],
    [l],
    [
      /ome\/([\w\.]+) \w* ?(iron) saf/i,
      // Iron
      /ome\/([\w\.]+).+qihu (360)[es]e/i
      // 360
    ],
    [d, l],
    [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
      // Facebook App for iOS & Android
    ],
    [[l, It], d, [a, ge]],
    [
      /(Klarna)\/([\w\.]+)/i,
      // Klarna Shopping Browser for iOS & Android
      /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
      // Kakao App
      /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
      // Naver InApp
      /(daum)apps[\/ ]([\w\.]+)/i,
      // Daum App
      /safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(alipay)client\/([\w\.]+)/i,
      // Alipay
      /(twitter)(?:and| f.+e\/([\w\.]+))/i,
      // Twitter
      /(instagram|snapchat)[\/ ]([-\w\.]+)/i
      // Instagram/Snapchat
    ],
    [l, d, [a, ge]],
    [
      /\bgsa\/([\w\.]+) .*safari\//i
      // Google Search Appliance on iOS
    ],
    [d, [l, "GSA"], [a, ge]],
    [
      /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
      // TikTok
    ],
    [d, [l, "TikTok"], [a, ge]],
    [
      /\[(linkedin)app\]/i
      // LinkedIn App for iOS & Android
    ],
    [l, [a, ge]],
    [
      /(chromium)[\/ ]([-\w\.]+)/i
      // Chromium
    ],
    [l, d],
    [
      /headlesschrome(?:\/([\w\.]+)| )/i
      // Chrome Headless
    ],
    [d, [l, Pt + " Headless"]],
    [
      / wv\).+(chrome)\/([\w\.]+)/i
      // Chrome WebView
    ],
    [[l, Pt + " WebView"], d],
    [
      /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
      // Android Browser
    ],
    [d, [l, "Android" + Se]],
    [
      /chrome\/([\w\.]+) mobile/i
      // Chrome Mobile
    ],
    [d, [l, ue + "Chrome"]],
    [
      /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
      // Chrome/OmniWeb/Arora/Tizen/Nokia
    ],
    [l, d],
    [
      /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
      // Safari Mobile
    ],
    [d, [l, ue + "Safari"]],
    [
      /iphone .*mobile(?:\/\w+ | ?)safari/i
    ],
    [[l, ue + "Safari"]],
    [
      /version\/([\w\.\,]+) .*(safari)/i
      // Safari
    ],
    [d, l],
    [
      /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
      // Safari < 3.0
    ],
    [l, [d, "1"]],
    [
      /(webkit|khtml)\/([\w\.]+)/i
    ],
    [l, d],
    [
      // Gecko based
      /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
      // Firefox Mobile
    ],
    [[l, ue + ve], d],
    [
      /(navigator|netscape\d?)\/([-\w\.]+)/i
      // Netscape
    ],
    [[l, "Netscape"], d],
    [
      /(wolvic|librewolf)\/([\w\.]+)/i
      // Wolvic/LibreWolf
    ],
    [l, d],
    [
      /mobile vr; rv:([\w\.]+)\).+firefox/i
      // Firefox Reality
    ],
    [d, [l, ve + " Reality"]],
    [
      /ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
      // Mozilla
      // Other
      /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
      /\b(links) \(([\w\.]+)/i
      // Links
    ],
    [l, [d, /_/g, "."]],
    [
      /(cobalt)\/([\w\.]+)/i
      // Cobalt
    ],
    [l, [d, /[^\d\.]+./, fe]]
  ],
  cpu: [
    [
      /\b((amd|x|x86[-_]?|wow|win)64)\b/i
      // AMD64 (x64)
    ],
    [[N, "amd64"]],
    [
      /(ia32(?=;))/i,
      // IA32 (quicktime)
      /\b((i[346]|x)86)(pc)?\b/i
      // IA32 (x86)
    ],
    [[N, "ia32"]],
    [
      /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
      // ARM64
    ],
    [[N, "arm64"]],
    [
      /\b(arm(v[67])?ht?n?[fl]p?)\b/i
      // ARMHF
    ],
    [[N, "armhf"]],
    [
      // PocketPC mistakenly identified as PowerPC
      /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
    ],
    [[N, "arm"]],
    [
      /((ppc|powerpc)(64)?)( mac|;|\))/i
      // PowerPC
    ],
    [[N, /ower/, fe, J]],
    [
      / sun4\w[;\)]/i
      // SPARC
    ],
    [[N, "sparc"]],
    [
      /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
    ],
    [[N, J]]
  ],
  device: [
    [
      //////////////////////////
      // MOBILES & TABLETS
      /////////////////////////
      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
    ],
    [u, [h, me], [a, k]],
    [
      /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
      /samsung[- ]((?!sm-[lr])[-\w]+)/i,
      /sec-(sgh\w+)/i
    ],
    [u, [h, me], [a, b]],
    [
      // Apple
      /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
      // iPod/iPhone
    ],
    [u, [h, ce], [a, b]],
    [
      /\((ipad);[-\w\),; ]+apple/i,
      // iPad
      /applecoremedia\/[\w\.]+ \((ipad)/i,
      /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
    ],
    [u, [h, ce], [a, k]],
    [
      /(macintosh);/i
    ],
    [u, [h, ce]],
    [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
    ],
    [u, [h, Ot], [a, b]],
    [
      // Honor
      /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
    ],
    [u, [h, xt], [a, k]],
    [
      /honor([-\w ]+)[;\)]/i
    ],
    [u, [h, xt], [a, b]],
    [
      // Huawei
      /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
    ],
    [u, [h, Tt], [a, k]],
    [
      /(?:huawei)([-\w ]+)[;\)]/i,
      /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
    ],
    [u, [h, Tt], [a, b]],
    [
      // Xiaomi
      /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
      /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
      // Mi Pad tablets
    ],
    [[u, /_/g, " "], [h, st], [a, k]],
    [
      /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
      // Xiaomi Redmi 'numeric' models
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
      // Xiaomi Mi
      / ([\w ]+) miui\/v?\d/i
    ],
    [[u, /_/g, " "], [h, st], [a, b]],
    [
      // OPPO
      /; (\w+) bui.+ oppo/i,
      /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
    ],
    [u, [h, it], [a, b]],
    [
      /\b(opd2(\d{3}a?))(?: bui|\))/i
    ],
    [u, [h, te, { OnePlus: ["304", "403", "203"], "*": it }], [a, k]],
    [
      // Vivo
      /vivo (\w+)(?: bui|\))/i,
      /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
    ],
    [u, [h, "Vivo"], [a, b]],
    [
      // Realme
      /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
    ],
    [u, [h, "Realme"], [a, b]],
    [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
      /\bmot(?:orola)?[- ](\w*)/i,
      /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
    ],
    [u, [h, tt], [a, b]],
    [
      /\b(mz60\d|xoom[2 ]{0,2}) build\//i
    ],
    [u, [h, tt], [a, k]],
    [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
    ],
    [u, [h, Le], [a, k]],
    [
      /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
      /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
      /\blg-?([\d\w]+) bui/i
    ],
    [u, [h, Le], [a, b]],
    [
      // Lenovo
      /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
      /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
    ],
    [u, [h, Ct], [a, k]],
    [
      // Nokia
      /(nokia) (t[12][01])/i
    ],
    [h, u, [a, k]],
    [
      /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
      /nokia[-_ ]?(([-\w\. ]*))/i
    ],
    [[u, /_/g, " "], [a, b], [h, "Nokia"]],
    [
      // Google
      /(pixel (c|tablet))\b/i
      // Google Pixel C/Tablet
    ],
    [u, [h, re], [a, k]],
    [
      /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
      // Google Pixel
    ],
    [u, [h, re], [a, b]],
    [
      // Sony
      /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
    ],
    [u, [h, we], [a, b]],
    [
      /sony tablet [ps]/i,
      /\b(?:sony)?sgp\w+(?: bui|\))/i
    ],
    [[u, "Xperia Tablet"], [h, we], [a, k]],
    [
      // OnePlus
      / (kb2005|in20[12]5|be20[12][59])\b/i,
      /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
    ],
    [u, [h, Rt], [a, b]],
    [
      // Amazon
      /(alexa)webm/i,
      /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
      // Kindle Fire without Silk / Echo Show
      /(kf[a-z]+)( bui|\)).+silk\//i
      // Kindle Fire HD
    ],
    [u, [h, Ie], [a, k]],
    [
      /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
      // Fire Phone
    ],
    [[u, /(.+)/g, "Fire Phone $1"], [h, Ie], [a, b]],
    [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i
      // BlackBerry PlayBook
    ],
    [u, h, [a, k]],
    [
      /\b((?:bb[a-f]|st[hv])100-\d)/i,
      /\(bb10; (\w+)/i
      // BlackBerry 10
    ],
    [u, [h, Et], [a, b]],
    [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
    ],
    [u, [h, kt], [a, k]],
    [
      / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
    ],
    [u, [h, kt], [a, b]],
    [
      // HTC
      /(nexus 9)/i
      // HTC Nexus 9
    ],
    [u, [h, "HTC"], [a, k]],
    [
      /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC
      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
      /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
      // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
    ],
    [h, [u, /_/g, " "], [a, b]],
    [
      // TCL
      /tcl (xess p17aa)/i,
      /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i
    ],
    [u, [h, "TCL"], [a, k]],
    [
      /droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i
    ],
    [u, [h, "TCL"], [a, b]],
    [
      // itel
      /(itel) ((\w+))/i
    ],
    [[h, J], u, [a, te, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
    [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
    ],
    [u, [h, "Acer"], [a, k]],
    [
      // Meizu
      /droid.+; (m[1-5] note) bui/i,
      /\bmz-([-\w]{2,})/i
    ],
    [u, [h, "Meizu"], [a, b]],
    [
      // Ulefone
      /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
    ],
    [u, [h, "Ulefone"], [a, b]],
    [
      // Energizer
      /; (energy ?\w+)(?: bui|\))/i,
      /; energizer ([\w ]+)(?: bui|\))/i
    ],
    [u, [h, "Energizer"], [a, b]],
    [
      // Cat
      /; cat (b35);/i,
      /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
    ],
    [u, [h, "Cat"], [a, b]],
    [
      // Smartfren
      /((?:new )?andromax[\w- ]+)(?: bui|\))/i
    ],
    [u, [h, "Smartfren"], [a, b]],
    [
      // Nothing
      /droid.+; (a(?:015|06[35]|142p?))/i
    ],
    [u, [h, "Nothing"], [a, b]],
    [
      // MIXED
      /(imo) (tab \w+)/i,
      // IMO
      /(infinix) (x1101b?)/i
      // Infinix XPad
    ],
    [h, u, [a, k]],
    [
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
      /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
      // HMD/IMO
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
      // Lenovo
      /(oppo) ?([\w ]+) bui/i
      // OPPO
    ],
    [h, u, [a, b]],
    [
      /(kobo)\s(ereader|touch)/i,
      // Kobo
      /(archos) (gamepad2?)/i,
      // Archos
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i
      // Kindle
    ],
    [h, u, [a, k]],
    [
      /(surface duo)/i
      // Surface Duo
    ],
    [u, [h, et], [a, k]],
    [
      /droid [\d\.]+; (fp\du?)(?: b|\))/i
      // Fairphone
    ],
    [u, [h, "Fairphone"], [a, b]],
    [
      /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
      // Nvidia Tablets
    ],
    [u, [h, nt], [a, k]],
    [
      /(sprint) (\w+)/i
      // Sprint Phones
    ],
    [h, u, [a, b]],
    [
      /(kin\.[onetw]{3})/i
      // Microsoft Kin
    ],
    [[u, /\./g, " "], [h, et], [a, b]],
    [
      /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
      // Zebra
    ],
    [u, [h, rt], [a, k]],
    [
      /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
    ],
    [u, [h, rt], [a, b]],
    [
      ///////////////////
      // SMARTTVS
      ///////////////////
      /smart-tv.+(samsung)/i
      // Samsung
    ],
    [h, [a, A]],
    [
      /hbbtv.+maple;(\d+)/i
    ],
    [[u, /^/, "SmartTV"], [h, me], [a, A]],
    [
      /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
      // LG SmartTV
    ],
    [[h, Le], [a, A]],
    [
      /(apple) ?tv/i
      // Apple TV
    ],
    [h, [u, ce + " TV"], [a, A]],
    [
      /crkey.*devicetype\/chromecast/i
      // Google Chromecast Third Generation
    ],
    [[u, Q + " Third Generation"], [h, re], [a, A]],
    [
      /crkey.*devicetype\/([^/]*)/i
      // Google Chromecast with specific device type
    ],
    [[u, /^/, "Chromecast "], [h, re], [a, A]],
    [
      /fuchsia.*crkey/i
      // Google Chromecast Nest Hub
    ],
    [[u, Q + " Nest Hub"], [h, re], [a, A]],
    [
      /crkey/i
      // Google Chromecast, Linux-based or unknown
    ],
    [[u, Q], [h, re], [a, A]],
    [
      /droid.+aft(\w+)( bui|\))/i
      // Fire TV
    ],
    [u, [h, Ie], [a, A]],
    [
      /(shield \w+ tv)/i
      // Nvidia Shield TV
    ],
    [u, [h, nt], [a, A]],
    [
      /\(dtv[\);].+(aquos)/i,
      /(aquos-tv[\w ]+)\)/i
      // Sharp
    ],
    [u, [h, Ot], [a, A]],
    [
      /(bravia[\w ]+)( bui|\))/i
      // Sony
    ],
    [u, [h, we], [a, A]],
    [
      /(mi(tv|box)-?\w+) bui/i
      // Xiaomi
    ],
    [u, [h, st], [a, A]],
    [
      /Hbbtv.*(technisat) (.*);/i
      // TechniSAT
    ],
    [h, u, [a, A]],
    [
      /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
      // HbbTV devices
    ],
    [[h, Oe], [u, Oe], [a, A]],
    [
      // SmartTV from Unidentified Vendors
      /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
    ],
    [u, [a, A]],
    [
      /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
    ],
    [[a, A]],
    [
      ///////////////////
      // CONSOLES
      ///////////////////
      /(ouya)/i,
      // Ouya
      /(nintendo) (\w+)/i
      // Nintendo
    ],
    [h, u, [a, Ee]],
    [
      /droid.+; (shield)( bui|\))/i
      // Nvidia Portable
    ],
    [u, [h, nt], [a, Ee]],
    [
      /(playstation \w+)/i
      // Playstation
    ],
    [u, [h, we], [a, Ee]],
    [
      /\b(xbox(?: one)?(?!; xbox))[\); ]/i
      // Microsoft Xbox
    ],
    [u, [h, et], [a, Ee]],
    [
      ///////////////////
      // WEARABLES
      ///////////////////
      /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
      // Samsung Galaxy Watch
    ],
    [u, [h, me], [a, $]],
    [
      /((pebble))app/i,
      // Pebble
      /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
      // Asus ZenWatch / LG Watch / Pixel Watch
    ],
    [h, u, [a, $]],
    [
      /(ow(?:19|20)?we?[1-3]{1,3})/i
      // Oppo Watch
    ],
    [u, [h, it], [a, $]],
    [
      /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
      // Apple Watch
    ],
    [u, [h, ce], [a, $]],
    [
      /(opwwe\d{3})/i
      // OnePlus Watch
    ],
    [u, [h, Rt], [a, $]],
    [
      /(moto 360)/i
      // Motorola 360
    ],
    [u, [h, tt], [a, $]],
    [
      /(smartwatch 3)/i
      // Sony SmartWatch
    ],
    [u, [h, we], [a, $]],
    [
      /(g watch r)/i
      // LG G Watch R
    ],
    [u, [h, Le], [a, $]],
    [
      /droid.+; (wt63?0{2,3})\)/i
    ],
    [u, [h, rt], [a, $]],
    [
      ///////////////////
      // XR
      ///////////////////
      /droid.+; (glass) \d/i
      // Google Glass
    ],
    [u, [h, re], [a, Qe]],
    [
      /(pico) (4|neo3(?: link|pro)?)/i
      // Pico
    ],
    [h, u, [a, Qe]],
    [
      /; (quest( \d| pro)?)/i
      // Oculus Quest
    ],
    [u, [h, It], [a, Qe]],
    [
      ///////////////////
      // EMBEDDED
      ///////////////////
      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
      // Tesla
    ],
    [h, [a, Te]],
    [
      /(aeobc)\b/i
      // Echo Dot
    ],
    [u, [h, Ie], [a, Te]],
    [
      /(homepod).+mac os/i
      // Apple HomePod
    ],
    [u, [h, ce], [a, Te]],
    [
      /windows iot/i
    ],
    [[a, Te]],
    [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////
      /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+?(mobile|vr|\d) safari/i
    ],
    [u, [a, te, { mobile: "Mobile", xr: "VR", "*": k }]],
    [
      /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
      // Unidentifiable Tablet
    ],
    [[a, k]],
    [
      /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
      // Unidentifiable Mobile
    ],
    [[a, b]],
    [
      /droid .+?; ([\w\. -]+)( bui|\))/i
      // Generic Android Device
    ],
    [u, [h, "Generic"]]
  ],
  engine: [
    [
      /windows.+ edge\/([\w\.]+)/i
      // EdgeHTML
    ],
    [d, [l, kn + "HTML"]],
    [
      /(arkweb)\/([\w\.]+)/i
      // ArkWeb
    ],
    [l, d],
    [
      /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
      // Blink
    ],
    [d, [l, "Blink"]],
    [
      /(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i,
      // iCab
      /\b(libweb)/i
      // LibWeb
    ],
    [l, d],
    [
      /ladybird\//i
    ],
    [[l, "LibWeb"]],
    [
      /rv\:([\w\.]{1,9})\b.+(gecko)/i
      // Gecko
    ],
    [d, l]
  ],
  os: [
    [
      // Windows
      /microsoft (windows) (vista|xp)/i
      // Windows (iTunes)
    ],
    [l, d],
    [
      /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
      // Windows Phone
    ],
    [l, [d, te, Dt]],
    [
      /windows nt 6\.2; (arm)/i,
      // Windows RT
      /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
      /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
    ],
    [[d, te, Dt], [l, dt]],
    [
      // iOS/macOS
      /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
      /cfnetwork\/.+darwin/i
    ],
    [[d, /_/g, "."], [l, "iOS"]],
    [
      /(mac os x) ?([\w\. ]*)/i,
      /(macintosh|mac_powerpc\b)(?!.+haiku)/i
      // Mac OS
    ],
    [[l, "macOS"], [d, /_/g, "."]],
    [
      // Google Chromecast
      /android ([\d\.]+).*crkey/i
      // Google Chromecast, Android-based
    ],
    [d, [l, Q + " Android"]],
    [
      /fuchsia.*crkey\/([\d\.]+)/i
      // Google Chromecast, Fuchsia-based
    ],
    [d, [l, Q + " Fuchsia"]],
    [
      /crkey\/([\d\.]+).*devicetype\/smartspeaker/i
      // Google Chromecast, Linux-based Smart Speaker
    ],
    [d, [l, Q + " SmartSpeaker"]],
    [
      /linux.*crkey\/([\d\.]+)/i
      // Google Chromecast, Legacy Linux-based
    ],
    [d, [l, Q + " Linux"]],
    [
      /crkey\/([\d\.]+)/i
      // Google Chromecast, unknown
    ],
    [d, [l, Q]],
    [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
      // Android-x86/HarmonyOS
    ],
    [d, l],
    [
      /(ubuntu) ([\w\.]+) like android/i
      // Ubuntu Touch
    ],
    [[l, /(.+)/, "$1 Touch"], d],
    [
      // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
      /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
    ],
    [l, d],
    [
      /\(bb(10);/i
      // BlackBerry 10
    ],
    [d, [l, Et]],
    [
      /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
      // Symbian
    ],
    [d, [l, "Symbian"]],
    [
      /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
      // Firefox OS
    ],
    [d, [l, ve + " OS"]],
    [
      /web0s;.+rt(tv)/i,
      /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
      // WebOS
    ],
    [d, [l, "webOS"]],
    [
      /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
      // watchOS
    ],
    [d, [l, "watchOS"]],
    [
      // Google ChromeOS
      /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
      // Chromium OS
    ],
    [[l, "Chrome OS"], d],
    [
      // Smart TVs
      /panasonic;(viera)/i,
      // Panasonic Viera
      /(netrange)mmh/i,
      // Netrange
      /(nettv)\/(\d+\.[\w\.]+)/i,
      // NetTV
      // Console
      /(nintendo|playstation) (\w+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)
      /(pico) .+os([\w\.]+)/i,
      // Pico
      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /(mint)[\/\(\) ]?(\w*)/i,
      // Mint
      /(mageia|vectorlinux)[; ]/i,
      // Mageia/VectorLinux
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
      /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
      // Hurd/Linux
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) (\w+)/i
      // Haiku
    ],
    [l, d],
    [
      /(sunos) ?([\w\.\d]*)/i
      // Solaris
    ],
    [[l, "Solaris"], d],
    [
      /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
      // AIX
      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
      // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
      /(unix) ?([\w\.]*)/i
      // UNIX
    ],
    [l, d]
  ]
}, De = function() {
  var i = { init: {}, isIgnore: {}, isIgnoreRgx: {}, toString: {} };
  return X.call(i.init, [
    [z, [l, d, Re, a]],
    [G, [N]],
    [K, [a, u, h]],
    [F, [l, d]],
    [B, [l, d]]
  ]), X.call(i.isIgnore, [
    [z, [d, Re]],
    [F, [d]],
    [B, [d]]
  ]), X.call(i.isIgnoreRgx, [
    [z, / ?browser$/i],
    [B, / ?os$/i]
  ]), X.call(i.toString, [
    [z, [l, d]],
    [G, [N]],
    [K, [h, u]],
    [F, [l, d]],
    [B, [l, d]]
  ]), i;
}(), Cn = function(i, e) {
  var t = De.init[e], n = De.isIgnore[e] || 0, s = De.isIgnoreRgx[e] || 0, r = De.toString[e] || 0;
  function o() {
    X.call(this, t);
  }
  return o.prototype.getItem = function() {
    return i;
  }, o.prototype.withClientHints = function() {
    return ee ? ee.getHighEntropyValues(Bt).then(function(f) {
      return i.setCH(new Ft(f, !1)).parseCH().get();
    }) : i.parseCH().get();
  }, o.prototype.withFeatureCheck = function() {
    return i.detectFeature().get();
  }, e != le && (o.prototype.is = function(f) {
    var c = !1;
    for (var _ in this)
      if (this.hasOwnProperty(_) && !ft(n, _) && J(s ? _e(s, this[_]) : this[_]) == J(s ? _e(s, f) : f)) {
        if (c = !0, f != ie) break;
      } else if (f == ie && c) {
        c = !c;
        break;
      }
    return c;
  }, o.prototype.toString = function() {
    var f = fe;
    for (var c in r)
      typeof this[r[c]] !== ie && (f += (f ? " " : fe) + this[r[c]]);
    return f || ie;
  }), ee || (o.prototype.then = function(f) {
    var c = this, _ = function() {
      for (var x in c)
        c.hasOwnProperty(x) && (this[x] = c[x]);
    };
    _.prototype = {
      is: o.prototype.is,
      toString: o.prototype.toString
    };
    var v = new _();
    return f(v), v;
  }), new o();
};
function Ft(i, e) {
  if (i = i || {}, X.call(this, Bt), e)
    X.call(this, [
      [_t, ot(i[se])],
      [bt, ot(i[bn])],
      [b, /\?1/.test(i[vn])],
      [u, ke(i[yn])],
      [he, ke(i[qt])],
      [gt, ke(i[Sn])],
      [N, ke(i[gn])],
      [ae, ot(i[wn])],
      [Ve, ke(i[mn])]
    ]);
  else
    for (var t in i)
      this.hasOwnProperty(t) && typeof i[t] !== ie && (this[t] = i[t]);
}
function zt(i, e, t, n) {
  return this.get = function(s) {
    return s ? this.data.hasOwnProperty(s) ? this.data[s] : void 0 : this.data;
  }, this.set = function(s, r) {
    return this.data[s] = r, this;
  }, this.setCH = function(s) {
    return this.uaCH = s, this;
  }, this.detectFeature = function() {
    if (M && M.userAgent == this.ua)
      switch (this.itemType) {
        case z:
          M.brave && typeof M.brave.isBrave == Me && this.set(l, "Brave");
          break;
        case K:
          !this.get(a) && ee && ee[b] && this.set(a, b), this.get(u) == "Macintosh" && M && typeof M.standalone !== ie && M.maxTouchPoints && M.maxTouchPoints > 2 && this.set(u, "iPad").set(a, k);
          break;
        case B:
          !this.get(l) && ee && ee[he] && this.set(l, ee[he]);
          break;
        case le:
          var s = this.data, r = function(o) {
            return s[o].getItem().detectFeature().get();
          };
          this.set(z, r(z)).set(G, r(G)).set(K, r(K)).set(F, r(F)).set(B, r(B));
      }
    return this;
  }, this.parseUA = function() {
    return this.itemType != le && ct.call(this.data, this.ua, this.rgxMap), this.itemType == z && this.set(Re, at(this.get(d))), this;
  }, this.parseCH = function() {
    var s = this.uaCH, r = this.rgxMap;
    switch (this.itemType) {
      case z:
      case F:
        var o = s[bt] || s[_t], f;
        if (o)
          for (var c in o) {
            var _ = o[c].brand || o[c], v = o[c].version;
            this.itemType == z && !/not.a.brand/i.test(_) && (!f || /chrom/i.test(f) && _ != At) && (_ = te(_, {
              Chrome: "Google Chrome",
              Edge: "Microsoft Edge",
              "Chrome WebView": "Android WebView",
              "Chrome Headless": "HeadlessChrome"
            }), this.set(l, _).set(d, v).set(Re, at(v)), f = _), this.itemType == F && _ == At && this.set(d, v);
          }
        break;
      case G:
        var x = s[N];
        x && (x && s[Ve] == "64" && (x += "64"), ct.call(this.data, x + ";", r));
        break;
      case K:
        if (s[b] && this.set(a, b), s[u] && (this.set(u, s[u]), !this.get(a) || !this.get(h))) {
          var P = {};
          ct.call(P, "droid 9; " + s[u] + ")", r), !this.get(a) && P.type && this.set(a, P.type), !this.get(h) && P.vendor && this.set(h, P.vendor);
        }
        if (s[ae]) {
          var y;
          if (typeof s[ae] != "string")
            for (var I = 0; !y && I < s[ae].length; )
              y = te(s[ae][I++], Ut);
          else
            y = te(s[ae], Ut);
          this.set(a, y);
        }
        break;
      case B:
        var T = s[he];
        if (T) {
          var E = s[gt];
          T == dt && (E = parseInt(at(E), 10) >= 13 ? "11" : "10"), this.set(l, T).set(d, E);
        }
        this.get(l) == dt && s[u] == "Xbox" && this.set(l, "Xbox").set(d, void 0);
        break;
      case le:
        var q = this.data, Z = function(w) {
          return q[w].getItem().setCH(s).parseCH().get();
        };
        this.set(z, Z(z)).set(G, Z(G)).set(K, Z(K)).set(F, Z(F)).set(B, Z(B));
    }
    return this;
  }, X.call(this, [
    ["itemType", i],
    ["ua", e],
    ["uaCH", n],
    ["rgxMap", t],
    ["data", Cn(this, i)]
  ]), this;
}
function V(i, e, t) {
  if (typeof i === pe ? (We(i, !0) ? (typeof e === pe && (t = e), e = i) : (t = i, e = void 0), i = void 0) : typeof i === ht && !We(e, !0) && (t = e, e = void 0), t && typeof t.append === Me) {
    var n = {};
    t.forEach(function(c, _) {
      n[_] = c;
    }), t = n;
  }
  if (!(this instanceof V))
    return new V(i, e, t).getResult();
  var s = typeof i === ht ? i : (
    // Passed user-agent string
    t && t[yt] ? t[yt] : (
      // User-Agent from passed headers
      M && M.userAgent ? M.userAgent : (
        // navigator.userAgent
        fe
      )
    )
  ), r = new Ft(t, !0), o = e ? Tn(jt, e) : jt, f = function(c) {
    return c == le ? function() {
      return new zt(c, s, o, r).set("ua", s).set(z, this.getBrowser()).set(G, this.getCPU()).set(K, this.getDevice()).set(F, this.getEngine()).set(B, this.getOS()).get();
    } : function() {
      return new zt(c, s, o[c], r).parseUA().get();
    };
  };
  return X.call(this, [
    ["getBrowser", f(z)],
    ["getCPU", f(G)],
    ["getDevice", f(K)],
    ["getEngine", f(F)],
    ["getOS", f(B)],
    ["getResult", f(le)],
    ["getUA", function() {
      return s;
    }],
    ["setUA", function(c) {
      return be(c) && (s = c.length > lt ? Oe(c, lt) : c), this;
    }]
  ]).setUA(s), this;
}
V.VERSION = _n;
V.BROWSER = $e([l, d, Re, a]);
V.CPU = $e([N]);
V.DEVICE = $e([u, h, a, Ee, b, A, k, $, Te]);
V.ENGINE = V.OS = $e([l, d]);
var je = /* @__PURE__ */ ((i) => (i.PHONE = "phone", i.TABLET = "tablet", i.DESKTOP = "desktop", i))(je || {}), oe = /* @__PURE__ */ ((i) => (i.ANDROID = "android", i.IOS = "ios", i.MAC = "mac", i.WIN = "win", i.LINUX = "linux", i.UNKNOWN = "unknown", i))(oe || {});
function xn(i) {
  const e = i.toLowerCase();
  return {
    detectOS() {
      return /android/.test(e) ? oe.ANDROID : /iphone|ipad|ipod/.test(e) ? oe.IOS : /macintosh|mac os x/.test(e) ? oe.MAC : /windows/.test(e) ? oe.WIN : /linux/.test(e) ? oe.LINUX : oe.UNKNOWN;
    },
    detectDeviceType() {
      const t = /iphone|ipod|android.*mobile|windows phone|blackberry|webos/.test(
        e
      ), n = /ipad|android(?!.*mobile)|tablet/.test(e);
      return t ? je.PHONE : n ? je.TABLET : je.DESKTOP;
    },
    detectDeviceName() {
      const n = new V().getResult();
      return n.device && n.device.model ? `${n.device.vendor} ${n.device.model}` : n.os && n.os.name ? `${n.os.name} ${n.os.version}` : "Unknown Device";
    },
    getTimezone() {
      const n = (/* @__PURE__ */ new Date()).toString().match(/GMT[+-]\d{4}/);
      return n ? n[0] : "";
    },
    getBrowserName() {
      return new V(i).getBrowser().name || "";
    },
    getBrowserVersion() {
      return new V(i).getBrowser().version || "";
    },
    detectOSVersion() {
      let t;
      return /android/.test(e) ? t = e.match(/android\s([0-9_.]+)/) : /iphone|ipad|ipod/.test(e) ? t = e.match(/os\s([0-9_]+)/) : /macintosh|mac os x/.test(e) ? t = e.match(/mac os x\s([0-9_.]+)/) : /windows/.test(e) ? t = e.match(/windows nt\s([0-9_.]+)/) : /linux/.test(e) && (t = e.match(/linux\s?([0-9_.]*)/)), t ? t[1].replace(/_/g, ".") : "unknown";
    }
  };
}
function p(i, e, t) {
  typeof console < "u" && console.debug && (t === "error" ? console.error(`[EwaAnalytics SDK] ${i}`, e || "") : console.debug(`[EwaAnalytics SDK] ${i}`, e || ""));
}
class Rn {
  config;
  userAgent;
  sessionLocated = !1;
  initialEventSent = !1;
  constructor(e) {
    this.config = e, this.userAgent = xn(e.globalConfig.initData.userAgent);
  }
  createMergedPayload(e, t) {
    return {
      ...e,
      ...this.config.globalConfig.initData,
      ...t,
      userAgent: this.userAgent,
      session_id: this.config.sessionId,
      environment: this.config.globalConfig.initData.environment
    };
  }
  updateSessionState(e) {
    switch (e) {
      case "located":
        this.sessionLocated = !0, p("Session marked as located");
        break;
      case "initial":
        this.initialEventSent = !0, p("Initial session events marked as sent");
        break;
      case "attributed":
        this.sessionLocated = !0, this.initialEventSent = !0, p("Session marked as attributed and ready for analytics");
        break;
    }
  }
  canTrackAnalyticsEvents() {
    return this.sessionLocated ? this.initialEventSent ? !0 : (console.warn(
      "[EwaAnalytics SDK] Initial session events not yet sent. Skipping analytics event tracking."
    ), !1) : (console.warn("[EwaAnalytics SDK] Session not yet located. Skipping analytics event tracking."), !1);
  }
  async trackEvent(e, t, n) {
    try {
      this.validateEventType(e), this.validatePayload(t);
      const s = this.createMergedPayload(t, n);
      if (e === "session")
        await this.trackSession(s);
      else if (e === "event")
        await this.trackAnalyticsEvent(s);
      else
        throw new Error(`Invalid event type: ${e}. Must be 'session' or 'event'`);
    } catch (s) {
      throw console.error(`[EwaAnalytics SDK] Error tracking ${e}:`, s), s;
    }
  }
  async trackSession(e) {
    try {
      const t = await hn(e);
      p(`Tracking session ${e.event_subtype}:`, t), this.updateSessionState(e.event_subtype), await this.sendToTransport(t, "session");
    } catch (t) {
      throw console.error("[EwaAnalytics SDK] Error tracking session:", t), t;
    }
  }
  async trackAnalyticsEvent(e) {
    try {
      if (!this.canTrackAnalyticsEvents())
        return;
      const t = await dn(e);
      p("Tracking event:", t), await this.sendToTransport(t, "event");
    } catch (t) {
      throw console.error("[EwaAnalytics SDK] Error tracking event:", t), t;
    }
  }
  async sendToTransport(e, t) {
    const n = t === "session" ? "analytics:sessions" : "analytics:events";
    switch (this.config.globalConfig.transport) {
      case "http":
        await this.postToHttp(e);
        break;
      case "websocket":
        await this.publishToWebSocket(n, e);
        break;
      default:
        throw new Error(`Unsupported transport: ${this.config.globalConfig.transport}`);
    }
  }
  async postToHttp(e) {
    if (!this.config.apiInstance)
      throw new Error("HTTP API instance not available");
    try {
      await this.config.apiInstance.post("/events", e);
    } catch (t) {
      throw console.error("[EwaAnalytics SDK] HTTP POST failed:", t), t;
    }
  }
  async publishToWebSocket(e, t) {
    if (!this.config.connection)
      throw new Error("WebSocket connection not available");
    try {
      this.config.connection.publish(e, t);
    } catch (n) {
      throw console.error("[EwaAnalytics SDK] WebSocket publish failed:", n), n;
    }
  }
  // Type-safe convenience methods
  async trackSessionTyped(e, t) {
    this.validatePayload(e);
    const n = t ? { ...t, ...e } : e;
    return this.trackEvent("session", n);
  }
  async trackEventTyped(e, t) {
    this.validatePayload(e);
    const n = t ? { ...t, ...e } : e;
    return this.trackEvent("event", n);
  }
  // Utility methods
  getTransport() {
    return this.config.globalConfig.transport;
  }
  getApiUrl() {
    return this.config.globalConfig.apiUrl;
  }
  isWebSocketTransport() {
    return this.config.globalConfig.transport === "websocket";
  }
  isHttpTransport() {
    return this.config.globalConfig.transport === "http";
  }
  isSessionLocated() {
    return this.sessionLocated;
  }
  areInitialEventsSent() {
    return this.initialEventSent;
  }
  getSessionState() {
    return {
      located: this.sessionLocated,
      initialEventSent: this.initialEventSent
    };
  }
  // Manual session state setters for edge cases
  setSessionLocated(e = !0) {
    this.sessionLocated = e, p(`Session located state manually set to: ${e}`);
  }
  setInitialEventsSent(e = !0) {
    this.initialEventSent = e, p(`Initial events sent state manually set to: ${e}`);
  }
  resetSessionState() {
    this.sessionLocated = !1, this.initialEventSent = !1, p("Session state reset");
  }
  // Validation methods
  validateEventType(e) {
    if (!e || typeof e != "string")
      throw new Error("Event type is required and must be a string");
    if (!["session", "event"].includes(e))
      throw new Error(`Invalid event type: ${e}. Must be 'session' or 'event'`);
  }
  validatePayload(e) {
    if (!e || typeof e != "object" || Array.isArray(e))
      throw new Error("Payload is required and must be an object");
    if (!e.event_name)
      throw new Error("Payload must contain an event_name field");
  }
}
function Ce(i, e, t, n) {
  function s(r) {
    return r instanceof t ? r : new t(function(o) {
      o(r);
    });
  }
  return new (t || (t = Promise))(function(r, o) {
    function f(v) {
      try {
        _(n.next(v));
      } catch (x) {
        o(x);
      }
    }
    function c(v) {
      try {
        _(n.throw(v));
      } catch (x) {
        o(x);
      }
    }
    function _(v) {
      v.done ? r(v.value) : s(v.value).then(f, c);
    }
    _((n = n.apply(i, [])).next());
  });
}
function On(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var mt = { exports: {} }, de = typeof Reflect == "object" ? Reflect : null, Nt = de && typeof de.apply == "function" ? de.apply : function(e, t, n) {
  return Function.prototype.apply.call(e, t, n);
}, ze;
de && typeof de.ownKeys == "function" ? ze = de.ownKeys : Object.getOwnPropertySymbols ? ze = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : ze = function(e) {
  return Object.getOwnPropertyNames(e);
};
function Pn(i) {
  console && console.warn && console.warn(i);
}
var Vt = Number.isNaN || function(e) {
  return e !== e;
};
function S() {
  S.init.call(this);
}
mt.exports = S;
mt.exports.once = Dn;
S.EventEmitter = S;
S.prototype._events = void 0;
S.prototype._eventsCount = 0;
S.prototype._maxListeners = void 0;
var Mt = 10;
function Ke(i) {
  if (typeof i != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof i);
}
Object.defineProperty(S, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Mt;
  },
  set: function(i) {
    if (typeof i != "number" || i < 0 || Vt(i))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + i + ".");
    Mt = i;
  }
});
S.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
S.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || Vt(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function $t(i) {
  return i._maxListeners === void 0 ? S.defaultMaxListeners : i._maxListeners;
}
S.prototype.getMaxListeners = function() {
  return $t(this);
};
S.prototype.emit = function(e) {
  for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
  var s = e === "error", r = this._events;
  if (r !== void 0)
    s = s && r.error === void 0;
  else if (!s)
    return !1;
  if (s) {
    var o;
    if (t.length > 0 && (o = t[0]), o instanceof Error)
      throw o;
    var f = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
    throw f.context = o, f;
  }
  var c = r[e];
  if (c === void 0)
    return !1;
  if (typeof c == "function")
    Nt(c, this, t);
  else
    for (var _ = c.length, v = Yt(c, _), n = 0; n < _; ++n)
      Nt(v[n], this, t);
  return !0;
};
function Kt(i, e, t, n) {
  var s, r, o;
  if (Ke(t), r = i._events, r === void 0 ? (r = i._events = /* @__PURE__ */ Object.create(null), i._eventsCount = 0) : (r.newListener !== void 0 && (i.emit(
    "newListener",
    e,
    t.listener ? t.listener : t
  ), r = i._events), o = r[e]), o === void 0)
    o = r[e] = t, ++i._eventsCount;
  else if (typeof o == "function" ? o = r[e] = n ? [t, o] : [o, t] : n ? o.unshift(t) : o.push(t), s = $t(i), s > 0 && o.length > s && !o.warned) {
    o.warned = !0;
    var f = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    f.name = "MaxListenersExceededWarning", f.emitter = i, f.type = e, f.count = o.length, Pn(f);
  }
  return i;
}
S.prototype.addListener = function(e, t) {
  return Kt(this, e, t, !1);
};
S.prototype.on = S.prototype.addListener;
S.prototype.prependListener = function(e, t) {
  return Kt(this, e, t, !0);
};
function An() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Gt(i, e, t) {
  var n = { fired: !1, wrapFn: void 0, target: i, type: e, listener: t }, s = An.bind(n);
  return s.listener = t, n.wrapFn = s, s;
}
S.prototype.once = function(e, t) {
  return Ke(t), this.on(e, Gt(this, e, t)), this;
};
S.prototype.prependOnceListener = function(e, t) {
  return Ke(t), this.prependListener(e, Gt(this, e, t)), this;
};
S.prototype.removeListener = function(e, t) {
  var n, s, r, o, f;
  if (Ke(t), s = this._events, s === void 0)
    return this;
  if (n = s[e], n === void 0)
    return this;
  if (n === t || n.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete s[e], s.removeListener && this.emit("removeListener", e, n.listener || t));
  else if (typeof n != "function") {
    for (r = -1, o = n.length - 1; o >= 0; o--)
      if (n[o] === t || n[o].listener === t) {
        f = n[o].listener, r = o;
        break;
      }
    if (r < 0)
      return this;
    r === 0 ? n.shift() : In(n, r), n.length === 1 && (s[e] = n[0]), s.removeListener !== void 0 && this.emit("removeListener", e, f || t);
  }
  return this;
};
S.prototype.off = S.prototype.removeListener;
S.prototype.removeAllListeners = function(e) {
  var t, n, s;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[e]), this;
  if (arguments.length === 0) {
    var r = Object.keys(n), o;
    for (s = 0; s < r.length; ++s)
      o = r[s], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = n[e], typeof t == "function")
    this.removeListener(e, t);
  else if (t !== void 0)
    for (s = t.length - 1; s >= 0; s--)
      this.removeListener(e, t[s]);
  return this;
};
function Jt(i, e, t) {
  var n = i._events;
  if (n === void 0)
    return [];
  var s = n[e];
  return s === void 0 ? [] : typeof s == "function" ? t ? [s.listener || s] : [s] : t ? Ln(s) : Yt(s, s.length);
}
S.prototype.listeners = function(e) {
  return Jt(this, e, !0);
};
S.prototype.rawListeners = function(e) {
  return Jt(this, e, !1);
};
S.listenerCount = function(i, e) {
  return typeof i.listenerCount == "function" ? i.listenerCount(e) : Xt.call(i, e);
};
S.prototype.listenerCount = Xt;
function Xt(i) {
  var e = this._events;
  if (e !== void 0) {
    var t = e[i];
    if (typeof t == "function")
      return 1;
    if (t !== void 0)
      return t.length;
  }
  return 0;
}
S.prototype.eventNames = function() {
  return this._eventsCount > 0 ? ze(this._events) : [];
};
function Yt(i, e) {
  for (var t = new Array(e), n = 0; n < e; ++n)
    t[n] = i[n];
  return t;
}
function In(i, e) {
  for (; e + 1 < i.length; e++)
    i[e] = i[e + 1];
  i.pop();
}
function Ln(i) {
  for (var e = new Array(i.length), t = 0; t < e.length; ++t)
    e[t] = i[t].listener || i[t];
  return e;
}
function Dn(i, e) {
  return new Promise(function(t, n) {
    function s(o) {
      i.removeListener(e, r), n(o);
    }
    function r() {
      typeof i.removeListener == "function" && i.removeListener("error", s), t([].slice.call(arguments));
    }
    Zt(i, e, r, { once: !0 }), e !== "error" && Un(i, s, { once: !0 });
  });
}
function Un(i, e, t) {
  typeof i.on == "function" && Zt(i, "error", e, t);
}
function Zt(i, e, t, n) {
  if (typeof i.on == "function")
    n.once ? i.once(e, t) : i.on(e, t);
  else if (typeof i.addEventListener == "function")
    i.addEventListener(e, function s(r) {
      n.once && i.removeEventListener(e, s), t(r);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof i);
}
var jn = mt.exports, Qt = /* @__PURE__ */ On(jn), C;
(function(i) {
  i[i.timeout = 1] = "timeout", i[i.transportClosed = 2] = "transportClosed", i[i.clientDisconnected = 3] = "clientDisconnected", i[i.clientClosed = 4] = "clientClosed", i[i.clientConnectToken = 5] = "clientConnectToken", i[i.clientRefreshToken = 6] = "clientRefreshToken", i[i.subscriptionUnsubscribed = 7] = "subscriptionUnsubscribed", i[i.subscriptionSubscribeToken = 8] = "subscriptionSubscribeToken", i[i.subscriptionRefreshToken = 9] = "subscriptionRefreshToken", i[i.transportWriteError = 10] = "transportWriteError", i[i.connectionClosed = 11] = "connectionClosed", i[i.badConfiguration = 12] = "badConfiguration";
})(C || (C = {}));
var ne;
(function(i) {
  i[i.connectCalled = 0] = "connectCalled", i[i.transportClosed = 1] = "transportClosed", i[i.noPing = 2] = "noPing", i[i.subscribeTimeout = 3] = "subscribeTimeout", i[i.unsubscribeError = 4] = "unsubscribeError";
})(ne || (ne = {}));
var xe;
(function(i) {
  i[i.disconnectCalled = 0] = "disconnectCalled", i[i.unauthorized = 1] = "unauthorized", i[i.badProtocol = 2] = "badProtocol", i[i.messageSizeLimit = 3] = "messageSizeLimit";
})(xe || (xe = {}));
var He;
(function(i) {
  i[i.subscribeCalled = 0] = "subscribeCalled", i[i.transportClosed = 1] = "transportClosed";
})(He || (He = {}));
var qe;
(function(i) {
  i[i.unsubscribeCalled = 0] = "unsubscribeCalled", i[i.unauthorized = 1] = "unauthorized", i[i.clientClosed = 2] = "clientClosed";
})(qe || (qe = {}));
var O;
(function(i) {
  i.Disconnected = "disconnected", i.Connecting = "connecting", i.Connected = "connected";
})(O || (O = {}));
var U;
(function(i) {
  i.Unsubscribed = "unsubscribed", i.Subscribing = "subscribing", i.Subscribed = "subscribed";
})(U || (U = {}));
function zn(i, e) {
  return i.lastIndexOf(e, 0) === 0;
}
function en(i) {
  return i == null ? !1 : typeof i == "function";
}
function Nn(i, e) {
  if (globalThis.console) {
    const t = globalThis.console[i];
    en(t) && t.apply(globalThis.console, e);
  }
}
function Mn(i, e) {
  return Math.floor(Math.random() * (e - i + 1) + i);
}
function Be(i, e, t) {
  i > 31 && (i = 31);
  const n = Mn(0, Math.min(t, e * Math.pow(2, i)));
  return Math.min(t, e + n);
}
function Wn(i) {
  return "error" in i && i.error !== null;
}
function Fe(i) {
  return Math.min(i * 1e3, 2147483647);
}
class Hn extends Qt {
  /** Subscription constructor should not be used directly, create subscriptions using Client method. */
  constructor(e, t, n) {
    super(), this._resubscribeTimeout = null, this._refreshTimeout = null, this.channel = t, this.state = U.Unsubscribed, this._centrifuge = e, this._token = "", this._getToken = null, this._data = null, this._getData = null, this._recover = !1, this._offset = null, this._epoch = null, this._recoverable = !1, this._positioned = !1, this._joinLeave = !1, this._minResubscribeDelay = 500, this._maxResubscribeDelay = 2e4, this._resubscribeTimeout = null, this._resubscribeAttempts = 0, this._promises = {}, this._promiseId = 0, this._inflight = !1, this._refreshTimeout = null, this._delta = "", this._delta_negotiated = !1, this._prevValue = null, this._unsubPromise = Promise.resolve(), this._setOptions(n), this._centrifuge._debugEnabled ? (this.on("state", (s) => {
      this._debug("subscription state", t, s.oldState, "->", s.newState);
    }), this.on("error", (s) => {
      this._debug("subscription error", t, s);
    })) : this.on("error", function() {
      Function.prototype();
    });
  }
  /** ready returns a Promise which resolves upon subscription goes to Subscribed
   * state and rejects in case of subscription goes to Unsubscribed state.
   * Optional timeout can be passed.*/
  ready(e) {
    return this.state === U.Unsubscribed ? Promise.reject({ code: C.subscriptionUnsubscribed, message: this.state }) : this.state === U.Subscribed ? Promise.resolve() : new Promise((t, n) => {
      const s = {
        resolve: t,
        reject: n
      };
      e && (s.timeout = setTimeout(function() {
        n({ code: C.timeout, message: "timeout" });
      }, e)), this._promises[this._nextPromiseId()] = s;
    });
  }
  /** subscribe to a channel.*/
  subscribe() {
    this._isSubscribed() || (this._resubscribeAttempts = 0, this._setSubscribing(He.subscribeCalled, "subscribe called"));
  }
  /** unsubscribe from a channel, keeping position state.*/
  unsubscribe() {
    this._unsubPromise = this._setUnsubscribed(qe.unsubscribeCalled, "unsubscribe called", !0);
  }
  /** publish data to a channel.*/
  publish(e) {
    const t = this;
    return this._methodCall().then(function() {
      return t._centrifuge.publish(t.channel, e);
    });
  }
  /** get online presence for a channel.*/
  presence() {
    const e = this;
    return this._methodCall().then(function() {
      return e._centrifuge.presence(e.channel);
    });
  }
  /** presence stats for a channel (num clients and unique users).*/
  presenceStats() {
    const e = this;
    return this._methodCall().then(function() {
      return e._centrifuge.presenceStats(e.channel);
    });
  }
  /** history for a channel. By default it does not return publications (only current
   *  StreamPosition data) – provide an explicit limit > 0 to load publications.*/
  history(e) {
    const t = this;
    return this._methodCall().then(function() {
      return t._centrifuge.history(t.channel, e);
    });
  }
  _methodCall() {
    return this._isSubscribed() ? Promise.resolve() : this._isUnsubscribed() ? Promise.reject({ code: C.subscriptionUnsubscribed, message: this.state }) : new Promise((e, t) => {
      const n = setTimeout(function() {
        t({ code: C.timeout, message: "timeout" });
      }, this._centrifuge._config.timeout);
      this._promises[this._nextPromiseId()] = {
        timeout: n,
        resolve: e,
        reject: t
      };
    });
  }
  _nextPromiseId() {
    return ++this._promiseId;
  }
  _needRecover() {
    return this._recover === !0;
  }
  _isUnsubscribed() {
    return this.state === U.Unsubscribed;
  }
  _isSubscribing() {
    return this.state === U.Subscribing;
  }
  _isSubscribed() {
    return this.state === U.Subscribed;
  }
  _setState(e) {
    if (this.state !== e) {
      const t = this.state;
      return this.state = e, this.emit("state", { newState: e, oldState: t, channel: this.channel }), !0;
    }
    return !1;
  }
  _usesToken() {
    return this._token !== "" || this._getToken !== null;
  }
  _clearSubscribingState() {
    this._resubscribeAttempts = 0, this._clearResubscribeTimeout();
  }
  _clearSubscribedState() {
    this._clearRefreshTimeout();
  }
  _setSubscribed(e) {
    if (!this._isSubscribing())
      return;
    this._clearSubscribingState(), e.recoverable && (this._recover = !0, this._offset = e.offset || 0, this._epoch = e.epoch || ""), e.delta ? this._delta_negotiated = !0 : this._delta_negotiated = !1, this._setState(U.Subscribed);
    const t = this._centrifuge._getSubscribeContext(this.channel, e);
    this.emit("subscribed", t), this._resolvePromises();
    const n = e.publications;
    if (n && n.length > 0)
      for (const s in n)
        n.hasOwnProperty(s) && this._handlePublication(n[s]);
    e.expires === !0 && (this._refreshTimeout = setTimeout(() => this._refresh(), Fe(e.ttl)));
  }
  _setSubscribing(e, t) {
    return Ce(this, void 0, void 0, function* () {
      this._isSubscribing() || (this._isSubscribed() && this._clearSubscribedState(), this._setState(U.Subscribing) && this.emit("subscribing", { channel: this.channel, code: e, reason: t }), this._centrifuge._transport && this._centrifuge._transport.emulation() && (yield this._unsubPromise), this._isSubscribing() && this._subscribe());
    });
  }
  _subscribe() {
    return this._debug("subscribing on", this.channel), this._isTransportOpen() ? this._inflight ? null : (this._inflight = !0, this._canSubscribeWithoutGettingToken() ? this._subscribeWithoutToken() : (this._getSubscriptionToken().then((e) => this._handleTokenResponse(e)).catch((e) => this._handleTokenError(e)), null)) : (this._debug("delay subscribe on", this.channel, "till connected"), null);
  }
  _isTransportOpen() {
    return this._centrifuge._transportIsOpen;
  }
  _canSubscribeWithoutGettingToken() {
    return !this._usesToken() || !!this._token;
  }
  _subscribeWithoutToken() {
    return this._getData ? (this._getDataAndSubscribe(this._token), null) : this._sendSubscribe(this._token);
  }
  _getDataAndSubscribe(e) {
    if (!this._getData) {
      this._inflight = !1;
      return;
    }
    this._getData({ channel: this.channel }).then((t) => {
      if (!this._isSubscribing()) {
        this._inflight = !1;
        return;
      }
      this._data = t, this._sendSubscribe(e);
    }).catch((t) => this._handleGetDataError(t));
  }
  _handleGetDataError(e) {
    if (!this._isSubscribing()) {
      this._inflight = !1;
      return;
    }
    if (e instanceof Y) {
      this._inflight = !1, this._failUnauthorized();
      return;
    }
    this.emit("error", {
      type: "subscribeData",
      channel: this.channel,
      error: {
        code: C.badConfiguration,
        message: e?.toString() || ""
      }
    }), this._inflight = !1, this._scheduleResubscribe();
  }
  _handleTokenResponse(e) {
    if (!this._isSubscribing()) {
      this._inflight = !1;
      return;
    }
    if (!e) {
      this._inflight = !1, this._failUnauthorized();
      return;
    }
    this._token = e, this._getData ? this._getDataAndSubscribe(e) : this._sendSubscribe(e);
  }
  _handleTokenError(e) {
    if (!this._isSubscribing()) {
      this._inflight = !1;
      return;
    }
    if (e instanceof Y) {
      this._inflight = !1, this._failUnauthorized();
      return;
    }
    this.emit("error", {
      type: "subscribeToken",
      channel: this.channel,
      error: {
        code: C.subscriptionSubscribeToken,
        message: e?.toString() || ""
      }
    }), this._inflight = !1, this._scheduleResubscribe();
  }
  _sendSubscribe(e) {
    if (!this._isTransportOpen())
      return this._inflight = !1, null;
    const t = this._buildSubscribeCommand(e);
    return this._centrifuge._call(t).then((n) => {
      this._inflight = !1;
      const s = n.reply.subscribe;
      this._handleSubscribeResponse(s), n.next && n.next();
    }, (n) => {
      this._inflight = !1, this._handleSubscribeError(n.error), n.next && n.next();
    }), t;
  }
  _buildSubscribeCommand(e) {
    const t = { channel: this.channel };
    if (e && (t.token = e), this._data && (t.data = this._data), this._positioned && (t.positioned = !0), this._recoverable && (t.recoverable = !0), this._joinLeave && (t.join_leave = !0), this._needRecover()) {
      t.recover = !0;
      const n = this._getOffset();
      n && (t.offset = n);
      const s = this._getEpoch();
      s && (t.epoch = s);
    }
    return this._delta && (t.delta = this._delta), { subscribe: t };
  }
  _debug(...e) {
    this._centrifuge._debug(...e);
  }
  _handleSubscribeError(e) {
    if (this._isSubscribing()) {
      if (e.code === C.timeout) {
        this._centrifuge._disconnect(ne.subscribeTimeout, "subscribe timeout", !0);
        return;
      }
      this._subscribeError(e);
    }
  }
  _handleSubscribeResponse(e) {
    this._isSubscribing() && this._setSubscribed(e);
  }
  _setUnsubscribed(e, t, n) {
    if (this._isUnsubscribed())
      return Promise.resolve();
    let s = Promise.resolve();
    return this._isSubscribed() ? (n && (s = this._centrifuge._unsubscribe(this)), this._clearSubscribedState()) : this._isSubscribing() && (this._inflight && n && (s = this._centrifuge._unsubscribe(this)), this._clearSubscribingState()), this._inflight = !1, this._setState(U.Unsubscribed) && this.emit("unsubscribed", { channel: this.channel, code: e, reason: t }), this._rejectPromises({ code: C.subscriptionUnsubscribed, message: this.state }), s;
  }
  _handlePublication(e) {
    if (this._delta && this._delta_negotiated) {
      const { newData: n, newPrevValue: s } = this._centrifuge._codec.applyDeltaIfNeeded(e, this._prevValue);
      e.data = n, this._prevValue = s;
    }
    const t = this._centrifuge._getPublicationContext(this.channel, e);
    this.emit("publication", t), e.offset && (this._offset = e.offset);
  }
  _handleJoin(e) {
    const t = this._centrifuge._getJoinLeaveContext(e.info);
    this.emit("join", { channel: this.channel, info: t });
  }
  _handleLeave(e) {
    const t = this._centrifuge._getJoinLeaveContext(e.info);
    this.emit("leave", { channel: this.channel, info: t });
  }
  _resolvePromises() {
    for (const e in this._promises)
      this._promises.hasOwnProperty(e) && (this._promises[e].timeout && clearTimeout(this._promises[e].timeout), this._promises[e].resolve(), delete this._promises[e]);
  }
  _rejectPromises(e) {
    for (const t in this._promises)
      this._promises.hasOwnProperty(t) && (this._promises[t].timeout && clearTimeout(this._promises[t].timeout), this._promises[t].reject(e), delete this._promises[t]);
  }
  _scheduleResubscribe() {
    if (!this._isSubscribing()) {
      this._debug("not in subscribing state, skip resubscribe scheduling", this.channel);
      return;
    }
    const e = this, t = this._getResubscribeDelay();
    this._resubscribeTimeout = setTimeout(function() {
      e._isSubscribing() && e._subscribe();
    }, t), this._debug("resubscribe scheduled after " + t, this.channel);
  }
  _subscribeError(e) {
    if (this._isSubscribing())
      if (e.code < 100 || e.code === 109 || e.temporary === !0) {
        e.code === 109 && (this._token = "");
        const t = {
          channel: this.channel,
          type: "subscribe",
          error: e
        };
        this._centrifuge.state === O.Connected && this.emit("error", t), this._scheduleResubscribe();
      } else
        this._setUnsubscribed(e.code, e.message, !1);
  }
  _getResubscribeDelay() {
    const e = Be(this._resubscribeAttempts, this._minResubscribeDelay, this._maxResubscribeDelay);
    return this._resubscribeAttempts++, e;
  }
  _setOptions(e) {
    if (e && (e.since && (this._offset = e.since.offset, this._epoch = e.since.epoch, this._recover = !0), e.data && (this._data = e.data), e.getData && (this._getData = e.getData), e.minResubscribeDelay !== void 0 && (this._minResubscribeDelay = e.minResubscribeDelay), e.maxResubscribeDelay !== void 0 && (this._maxResubscribeDelay = e.maxResubscribeDelay), e.token && (this._token = e.token), e.getToken && (this._getToken = e.getToken), e.positioned === !0 && (this._positioned = !0), e.recoverable === !0 && (this._recoverable = !0), e.joinLeave === !0 && (this._joinLeave = !0), e.delta)) {
      if (e.delta !== "fossil")
        throw new Error("unsupported delta format");
      this._delta = e.delta;
    }
  }
  _getOffset() {
    const e = this._offset;
    return e !== null ? e : 0;
  }
  _getEpoch() {
    const e = this._epoch;
    return e !== null ? e : "";
  }
  _clearRefreshTimeout() {
    this._refreshTimeout !== null && (clearTimeout(this._refreshTimeout), this._refreshTimeout = null);
  }
  _clearResubscribeTimeout() {
    this._resubscribeTimeout !== null && (clearTimeout(this._resubscribeTimeout), this._resubscribeTimeout = null);
  }
  _getSubscriptionToken() {
    this._debug("get subscription token for channel", this.channel);
    const e = {
      channel: this.channel
    }, t = this._getToken;
    if (t === null)
      throw this.emit("error", {
        type: "configuration",
        channel: this.channel,
        error: {
          code: C.badConfiguration,
          message: "provide a function to get channel subscription token"
        }
      }), new Y("");
    return t(e);
  }
  _refresh() {
    this._clearRefreshTimeout();
    const e = this;
    this._getSubscriptionToken().then(function(t) {
      if (!e._isSubscribed())
        return;
      if (!t) {
        e._failUnauthorized();
        return;
      }
      e._token = t;
      const s = {
        sub_refresh: {
          channel: e.channel,
          token: t
        }
      };
      e._centrifuge._call(s).then((r) => {
        const o = r.reply.sub_refresh;
        e._refreshResponse(o), r.next && r.next();
      }, (r) => {
        e._refreshError(r.error), r.next && r.next();
      });
    }).catch(function(t) {
      if (t instanceof Y) {
        e._failUnauthorized();
        return;
      }
      e.emit("error", {
        type: "refreshToken",
        channel: e.channel,
        error: {
          code: C.subscriptionRefreshToken,
          message: t !== void 0 ? t.toString() : ""
        }
      }), e._refreshTimeout = setTimeout(() => e._refresh(), e._getRefreshRetryDelay());
    });
  }
  _refreshResponse(e) {
    this._isSubscribed() && (this._debug("subscription token refreshed, channel", this.channel), this._clearRefreshTimeout(), e.expires === !0 && (this._refreshTimeout = setTimeout(() => this._refresh(), Fe(e.ttl))));
  }
  _refreshError(e) {
    this._isSubscribed() && (e.code < 100 || e.temporary === !0 ? (this.emit("error", {
      type: "refresh",
      channel: this.channel,
      error: e
    }), this._refreshTimeout = setTimeout(() => this._refresh(), this._getRefreshRetryDelay())) : this._setUnsubscribed(e.code, e.message, !0));
  }
  _getRefreshRetryDelay() {
    return Be(0, 1e4, 2e4);
  }
  _failUnauthorized() {
    this._setUnsubscribed(qe.unauthorized, "unauthorized", !0);
  }
}
class qn {
  constructor(e, t) {
    this.endpoint = e, this.options = t, this._transport = null;
  }
  name() {
    return "sockjs";
  }
  subName() {
    return "sockjs-" + this._transport.transport;
  }
  emulation() {
    return !1;
  }
  supported() {
    return this.options.sockjs !== null;
  }
  initialize(e, t) {
    this._transport = new this.options.sockjs(this.endpoint, null, this.options.sockjsOptions), this._transport.onopen = () => {
      t.onOpen();
    }, this._transport.onerror = (n) => {
      t.onError(n);
    }, this._transport.onclose = (n) => {
      t.onClose(n);
    }, this._transport.onmessage = (n) => {
      t.onMessage(n.data);
    };
  }
  close() {
    this._transport.close();
  }
  send(e) {
    this._transport.send(e);
  }
}
class Wt {
  constructor(e, t) {
    this.endpoint = e, this.options = t, this._transport = null;
  }
  name() {
    return "websocket";
  }
  subName() {
    return "websocket";
  }
  emulation() {
    return !1;
  }
  supported() {
    return this.options.websocket !== void 0 && this.options.websocket !== null;
  }
  initialize(e, t) {
    let n = "";
    e === "protobuf" && (n = "centrifuge-protobuf"), n !== "" ? this._transport = new this.options.websocket(this.endpoint, n) : this._transport = new this.options.websocket(this.endpoint), e === "protobuf" && (this._transport.binaryType = "arraybuffer"), this._transport.onopen = () => {
      t.onOpen();
    }, this._transport.onerror = (s) => {
      t.onError(s);
    }, this._transport.onclose = (s) => {
      t.onClose(s);
    }, this._transport.onmessage = (s) => {
      t.onMessage(s.data);
    };
  }
  close() {
    this._transport.close();
  }
  send(e) {
    this._transport.send(e);
  }
}
class Bn {
  constructor(e, t) {
    this.endpoint = e, this.options = t, this._abortController = null, this._utf8decoder = new TextDecoder(), this._protocol = "json";
  }
  name() {
    return "http_stream";
  }
  subName() {
    return "http_stream";
  }
  emulation() {
    return !0;
  }
  _handleErrors(e) {
    if (!e.ok)
      throw new Error(e.status);
    return e;
  }
  _fetchEventTarget(e, t, n) {
    const s = new EventTarget(), r = e.options.fetch;
    return r(t, n).then(e._handleErrors).then((o) => {
      s.dispatchEvent(new Event("open"));
      let f = "", c = 0, _ = new Uint8Array();
      const v = o.body.getReader();
      return new e.options.readableStream({
        start(x) {
          function P() {
            return v.read().then(({ done: y, value: I }) => {
              if (y) {
                s.dispatchEvent(new Event("close")), x.close();
                return;
              }
              try {
                if (e._protocol === "json")
                  for (f += e._utf8decoder.decode(I); c < f.length; )
                    if (f[c] === `
`) {
                      const T = f.substring(0, c);
                      s.dispatchEvent(new MessageEvent("message", { data: T })), f = f.substring(c + 1), c = 0;
                    } else
                      ++c;
                else {
                  const T = new Uint8Array(_.length + I.length);
                  for (T.set(_), T.set(I, _.length), _ = T; ; ) {
                    const E = e.options.decoder.decodeReply(_);
                    if (E.ok) {
                      const q = _.slice(0, E.pos);
                      s.dispatchEvent(new MessageEvent("message", { data: q })), _ = _.slice(E.pos);
                      continue;
                    }
                    break;
                  }
                }
              } catch (T) {
                s.dispatchEvent(new Event("error", { detail: T })), s.dispatchEvent(new Event("close")), x.close();
                return;
              }
              P();
            }).catch(function(y) {
              s.dispatchEvent(new Event("error", { detail: y })), s.dispatchEvent(new Event("close")), x.close();
            });
          }
          return P();
        }
      });
    }).catch((o) => {
      s.dispatchEvent(new Event("error", { detail: o })), s.dispatchEvent(new Event("close"));
    }), s;
  }
  supported() {
    return this.options.fetch !== null && this.options.readableStream !== null && typeof TextDecoder < "u" && typeof AbortController < "u" && typeof EventTarget < "u" && typeof Event < "u" && typeof MessageEvent < "u" && typeof Error < "u";
  }
  initialize(e, t, n) {
    this._protocol = e, this._abortController = new AbortController();
    let s, r;
    e === "json" ? (s = {
      Accept: "application/json",
      "Content-Type": "application/json"
    }, r = n) : (s = {
      Accept: "application/octet-stream",
      "Content-Type": "application/octet-stream"
    }, r = n);
    const o = {
      method: "POST",
      headers: s,
      body: r,
      mode: "cors",
      credentials: "same-origin",
      signal: this._abortController.signal
    }, f = this._fetchEventTarget(this, this.endpoint, o);
    f.addEventListener("open", () => {
      t.onOpen();
    }), f.addEventListener("error", (c) => {
      this._abortController.abort(), t.onError(c);
    }), f.addEventListener("close", () => {
      this._abortController.abort(), t.onClose({
        code: 4,
        reason: "connection closed"
      });
    }), f.addEventListener("message", (c) => {
      t.onMessage(c.data);
    });
  }
  close() {
    this._abortController.abort();
  }
  send(e, t, n) {
    let s, r;
    const o = {
      session: t,
      node: n,
      data: e
    };
    this._protocol === "json" ? (s = {
      "Content-Type": "application/json"
    }, r = JSON.stringify(o)) : (s = {
      "Content-Type": "application/octet-stream"
    }, r = this.options.encoder.encodeEmulationRequest(o));
    const f = this.options.fetch, c = {
      method: "POST",
      headers: s,
      body: r,
      mode: "cors",
      credentials: "same-origin"
    };
    f(this.options.emulationEndpoint, c);
  }
}
class Fn {
  constructor(e, t) {
    this.endpoint = e, this.options = t, this._protocol = "json", this._transport = null, this._onClose = null;
  }
  name() {
    return "sse";
  }
  subName() {
    return "sse";
  }
  emulation() {
    return !0;
  }
  supported() {
    return this.options.eventsource !== null && this.options.fetch !== null;
  }
  initialize(e, t, n) {
    let s;
    globalThis && globalThis.document && globalThis.document.baseURI ? s = new URL(this.endpoint, globalThis.document.baseURI) : s = new URL(this.endpoint), s.searchParams.append("cf_connect", n);
    const r = {}, o = new this.options.eventsource(s.toString(), r);
    this._transport = o;
    const f = this;
    o.onopen = function() {
      t.onOpen();
    }, o.onerror = function(c) {
      o.close(), t.onError(c), t.onClose({
        code: 4,
        reason: "connection closed"
      });
    }, o.onmessage = function(c) {
      t.onMessage(c.data);
    }, f._onClose = function() {
      t.onClose({
        code: 4,
        reason: "connection closed"
      });
    };
  }
  close() {
    this._transport.close(), this._onClose !== null && this._onClose();
  }
  send(e, t, n) {
    const s = {
      session: t,
      node: n,
      data: e
    }, r = {
      "Content-Type": "application/json"
    }, o = JSON.stringify(s), f = this.options.fetch, c = {
      method: "POST",
      headers: r,
      body: o,
      mode: "cors",
      credentials: "same-origin"
    };
    f(this.options.emulationEndpoint, c);
  }
}
class Vn {
  constructor(e, t) {
    this.endpoint = e, this.options = t, this._transport = null, this._stream = null, this._writer = null, this._utf8decoder = new TextDecoder(), this._protocol = "json";
  }
  name() {
    return "webtransport";
  }
  subName() {
    return "webtransport";
  }
  emulation() {
    return !1;
  }
  supported() {
    return this.options.webtransport !== void 0 && this.options.webtransport !== null;
  }
  initialize(e, t) {
    return Ce(this, void 0, void 0, function* () {
      let n;
      globalThis && globalThis.document && globalThis.document.baseURI ? n = new URL(this.endpoint, globalThis.document.baseURI) : n = new URL(this.endpoint), e === "protobuf" && n.searchParams.append("cf_protocol", "protobuf"), this._protocol = e;
      const s = new EventTarget();
      this._transport = new this.options.webtransport(n.toString()), this._transport.closed.then(() => {
        t.onClose({
          code: 4,
          reason: "connection closed"
        });
      }).catch(() => {
        t.onClose({
          code: 4,
          reason: "connection closed"
        });
      });
      try {
        yield this._transport.ready;
      } catch {
        this.close();
        return;
      }
      let r;
      try {
        r = yield this._transport.createBidirectionalStream();
      } catch {
        this.close();
        return;
      }
      this._stream = r, this._writer = this._stream.writable.getWriter(), s.addEventListener("close", () => {
        t.onClose({
          code: 4,
          reason: "connection closed"
        });
      }), s.addEventListener("message", (o) => {
        t.onMessage(o.data);
      }), this._startReading(s), t.onOpen();
    });
  }
  _startReading(e) {
    return Ce(this, void 0, void 0, function* () {
      const t = this._stream.readable.getReader();
      let n = "", s = 0, r = new Uint8Array();
      try {
        for (; ; ) {
          const { done: o, value: f } = yield t.read();
          if (f.length > 0)
            if (this._protocol === "json")
              for (n += this._utf8decoder.decode(f); s < n.length; )
                if (n[s] === `
`) {
                  const c = n.substring(0, s);
                  e.dispatchEvent(new MessageEvent("message", { data: c })), n = n.substring(s + 1), s = 0;
                } else
                  ++s;
            else {
              const c = new Uint8Array(r.length + f.length);
              for (c.set(r), c.set(f, r.length), r = c; ; ) {
                const _ = this.options.decoder.decodeReply(r);
                if (_.ok) {
                  const v = r.slice(0, _.pos);
                  e.dispatchEvent(new MessageEvent("message", { data: v })), r = r.slice(_.pos);
                  continue;
                }
                break;
              }
            }
          if (o)
            break;
        }
      } catch {
        e.dispatchEvent(new Event("close"));
      }
    });
  }
  close() {
    return Ce(this, void 0, void 0, function* () {
      try {
        this._writer && (yield this._writer.close()), this._transport.close();
      } catch {
      }
    });
  }
  send(e) {
    return Ce(this, void 0, void 0, function* () {
      let t;
      this._protocol === "json" ? t = new TextEncoder().encode(e + `
`) : t = e;
      try {
        yield this._writer.write(t);
      } catch {
        this.close();
      }
    });
  }
}
const $n = [
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  -1,
  -1,
  -1,
  -1,
  36,
  -1,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  -1,
  -1,
  -1,
  63,
  -1
];
class Kn {
  constructor(e) {
    this.a = e, this.pos = 0;
  }
  haveBytes() {
    return this.pos < this.a.length;
  }
  getByte() {
    const e = this.a[this.pos];
    if (this.pos++, this.pos > this.a.length)
      throw new RangeError("out of bounds");
    return e;
  }
  getChar() {
    return String.fromCharCode(this.getByte());
  }
  // Read base64-encoded unsigned integer.
  getInt() {
    let e = 0, t;
    for (; this.haveBytes() && (t = $n[127 & this.getByte()]) >= 0; )
      e = (e << 6) + t;
    return this.pos--, e >>> 0;
  }
}
class Gn {
  constructor() {
    this.a = [];
  }
  toByteArray(e) {
    return Array.isArray(e) ? this.a : new Uint8Array(this.a);
  }
  // Copy from array at start to end.
  putArray(e, t, n) {
    for (let s = t; s < n; s++)
      this.a.push(e[s]);
  }
}
function Jn(i) {
  let e = 0, t = 0, n = 0, s = 0, r = 0, o = i.length;
  for (; o >= 16; )
    e = e + i[r + 0] | 0, t = t + i[r + 1] | 0, n = n + i[r + 2] | 0, s = s + i[r + 3] | 0, e = e + i[r + 4] | 0, t = t + i[r + 5] | 0, n = n + i[r + 6] | 0, s = s + i[r + 7] | 0, e = e + i[r + 8] | 0, t = t + i[r + 9] | 0, n = n + i[r + 10] | 0, s = s + i[r + 11] | 0, e = e + i[r + 12] | 0, t = t + i[r + 13] | 0, n = n + i[r + 14] | 0, s = s + i[r + 15] | 0, r += 16, o -= 16;
  for (; o >= 4; )
    e = e + i[r + 0] | 0, t = t + i[r + 1] | 0, n = n + i[r + 2] | 0, s = s + i[r + 3] | 0, r += 4, o -= 4;
  switch (s = ((s + (n << 8) | 0) + (t << 16) | 0) + (e << 24) | 0, o) {
    case 3:
      s = s + (i[r + 2] << 8) | 0;
    case 2:
      s = s + (i[r + 1] << 16) | 0;
    case 1:
      s = s + (i[r + 0] << 24) | 0;
  }
  return s >>> 0;
}
function Xn(i, e) {
  let t = 0;
  const n = new Kn(e), s = i.length, r = e.length, o = n.getInt();
  if (n.getChar() !== `
`)
    throw new Error("size integer not terminated by '\\n'");
  const f = new Gn();
  for (; n.haveBytes(); ) {
    const c = n.getInt();
    let _;
    switch (n.getChar()) {
      case "@":
        if (_ = n.getInt(), n.haveBytes() && n.getChar() !== ",")
          throw new Error("copy command not terminated by ','");
        if (t += c, t > o)
          throw new Error("copy exceeds output file size");
        if (_ + c > s)
          throw new Error("copy extends past end of input");
        f.putArray(i, _, _ + c);
        break;
      case ":":
        if (t += c, t > o)
          throw new Error("insert command gives an output larger than predicted");
        if (c > r)
          throw new Error("insert count exceeds size of delta");
        f.putArray(n.a, n.pos, n.pos + c), n.pos += c;
        break;
      case ";": {
        const v = f.toByteArray(i);
        if (c !== Jn(v))
          throw new Error("bad checksum");
        if (t !== o)
          throw new Error("generated size does not match predicted size");
        return v;
      }
      default:
        throw new Error("unknown delta operator");
    }
  }
  throw new Error("unterminated delta");
}
class Ht {
  name() {
    return "json";
  }
  encodeCommands(e) {
    return e.map((t) => JSON.stringify(t)).join(`
`);
  }
  decodeReplies(e) {
    return e.trim().split(`
`).map((t) => JSON.parse(t));
  }
  applyDeltaIfNeeded(e, t) {
    let n, s;
    if (e.delta) {
      const r = Xn(t, new TextEncoder().encode(e.data));
      n = JSON.parse(new TextDecoder().decode(r)), s = r;
    } else
      n = JSON.parse(e.data), s = new TextEncoder().encode(e.data);
    return { newData: n, newPrevValue: s };
  }
}
const Yn = {
  headers: {},
  token: "",
  getToken: null,
  data: null,
  getData: null,
  debug: !1,
  name: "js",
  version: "",
  fetch: null,
  readableStream: null,
  websocket: null,
  eventsource: null,
  sockjs: null,
  sockjsOptions: {},
  emulationEndpoint: "/emulation",
  minReconnectDelay: 500,
  maxReconnectDelay: 2e4,
  timeout: 5e3,
  maxServerPingDelay: 1e4,
  networkEventTarget: null
};
class Y extends Error {
  constructor(e) {
    super(e), this.name = this.constructor.name;
  }
}
class Ge extends Qt {
  /** Constructs Centrifuge client. Call connect() method to start connecting. */
  constructor(e, t) {
    super(), this._reconnectTimeout = null, this._refreshTimeout = null, this._serverPingTimeout = null, this.state = O.Disconnected, this._transportIsOpen = !1, this._endpoint = e, this._emulation = !1, this._transports = [], this._currentTransportIndex = 0, this._triedAllTransports = !1, this._transportWasOpen = !1, this._transport = null, this._transportId = 0, this._deviceWentOffline = !1, this._transportClosed = !0, this._codec = new Ht(), this._reconnecting = !1, this._reconnectTimeout = null, this._reconnectAttempts = 0, this._client = null, this._session = "", this._node = "", this._subs = {}, this._serverSubs = {}, this._commandId = 0, this._commands = [], this._batching = !1, this._refreshRequired = !1, this._refreshTimeout = null, this._callbacks = {}, this._token = "", this._data = null, this._dispatchPromise = Promise.resolve(), this._serverPing = 0, this._serverPingTimeout = null, this._sendPong = !1, this._promises = {}, this._promiseId = 0, this._debugEnabled = !1, this._networkEventsSet = !1, this._config = Object.assign(Object.assign({}, Yn), t), this._configure(), this._debugEnabled ? (this.on("state", (n) => {
      this._debug("client state", n.oldState, "->", n.newState);
    }), this.on("error", (n) => {
      this._debug("client error", n);
    })) : this.on("error", function() {
      Function.prototype();
    });
  }
  /** newSubscription allocates new Subscription to a channel. Since server only allows
   * one subscription per channel per client this method throws if client already has
   * channel subscription in internal registry.
   * */
  newSubscription(e, t) {
    if (this.getSubscription(e) !== null)
      throw new Error("Subscription to the channel " + e + " already exists");
    const n = new Hn(this, e, t);
    return this._subs[e] = n, n;
  }
  /** getSubscription returns Subscription if it's registered in the internal
   * registry or null. */
  getSubscription(e) {
    return this._getSub(e);
  }
  /** removeSubscription allows removing Subcription from the internal registry. Subscrption
   * must be in unsubscribed state. */
  removeSubscription(e) {
    e && (e.state !== U.Unsubscribed && e.unsubscribe(), this._removeSubscription(e));
  }
  /** Get a map with all current client-side subscriptions. */
  subscriptions() {
    return this._subs;
  }
  /** ready returns a Promise which resolves upon client goes to Connected
   * state and rejects in case of client goes to Disconnected or Failed state.
   * Users can provide optional timeout in milliseconds. */
  ready(e) {
    return this.state === O.Disconnected ? Promise.reject({ code: C.clientDisconnected, message: "client disconnected" }) : this.state === O.Connected ? Promise.resolve() : new Promise((t, n) => {
      const s = {
        resolve: t,
        reject: n
      };
      e && (s.timeout = setTimeout(function() {
        n({ code: C.timeout, message: "timeout" });
      }, e)), this._promises[this._nextPromiseId()] = s;
    });
  }
  /** connect to a server. */
  connect() {
    if (this._isConnected()) {
      this._debug("connect called when already connected");
      return;
    }
    if (this._isConnecting()) {
      this._debug("connect called when already connecting");
      return;
    }
    this._debug("connect called"), this._reconnectAttempts = 0, this._startConnecting();
  }
  /** disconnect from a server. */
  disconnect() {
    this._disconnect(xe.disconnectCalled, "disconnect called", !1);
  }
  /** setToken allows setting connection token. Or resetting used token to be empty.  */
  setToken(e) {
    this._token = e;
  }
  /** setHeaders allows setting connection emulated headers. */
  setHeaders(e) {
    this._config.headers = e;
  }
  /** send asynchronous data to a server (without any response from a server
   * expected, see rpc method if you need response). */
  send(e) {
    const t = {
      send: {
        data: e
      }
    }, n = this;
    return this._methodCall().then(function() {
      return n._transportSendCommands([t]) ? Promise.resolve() : Promise.reject(n._createErrorObject(C.transportWriteError, "transport write error"));
    });
  }
  /** rpc to a server - i.e. a call which waits for a response with data. */
  rpc(e, t) {
    const n = {
      rpc: {
        method: e,
        data: t
      }
    }, s = this;
    return this._methodCall().then(function() {
      return s._callPromise(n, function(r) {
        return {
          data: r.rpc.data
        };
      });
    });
  }
  /** publish data to a channel. */
  publish(e, t) {
    const n = {
      publish: {
        channel: e,
        data: t
      }
    }, s = this;
    return this._methodCall().then(function() {
      return s._callPromise(n, function() {
        return {};
      });
    });
  }
  /** history for a channel. By default it does not return publications (only current
   *  StreamPosition data) – provide an explicit limit > 0 to load publications.*/
  history(e, t) {
    const n = {
      history: this._getHistoryRequest(e, t)
    }, s = this;
    return this._methodCall().then(function() {
      return s._callPromise(n, function(r) {
        const o = r.history, f = [];
        if (o.publications)
          for (let c = 0; c < o.publications.length; c++)
            f.push(s._getPublicationContext(e, o.publications[c]));
        return {
          publications: f,
          epoch: o.epoch || "",
          offset: o.offset || 0
        };
      });
    });
  }
  /** presence for a channel. */
  presence(e) {
    const t = {
      presence: {
        channel: e
      }
    }, n = this;
    return this._methodCall().then(function() {
      return n._callPromise(t, function(s) {
        const r = s.presence.presence;
        for (const o in r)
          if (r.hasOwnProperty(o)) {
            const f = r[o].conn_info, c = r[o].chan_info;
            f && (r[o].connInfo = f), c && (r[o].chanInfo = c);
          }
        return {
          clients: r
        };
      });
    });
  }
  /** presence stats for a channel. */
  presenceStats(e) {
    const t = {
      presence_stats: {
        channel: e
      }
    }, n = this;
    return this._methodCall().then(function() {
      return n._callPromise(t, function(s) {
        const r = s.presence_stats;
        return {
          numUsers: r.num_users,
          numClients: r.num_clients
        };
      });
    });
  }
  /** start command batching (collect into temporary buffer without sending to a server)
   * until stopBatching called.*/
  startBatching() {
    this._batching = !0;
  }
  /** stop batching commands and flush collected commands to the
   * network (all in one request/frame).*/
  stopBatching() {
    const e = this;
    Promise.resolve().then(function() {
      Promise.resolve().then(function() {
        e._batching = !1, e._flush();
      });
    });
  }
  _debug(...e) {
    this._debugEnabled && Nn("debug", e);
  }
  /** @internal */
  _formatOverride() {
  }
  _configure() {
    if (!("Promise" in globalThis))
      throw new Error("Promise polyfill required");
    if (!this._endpoint)
      throw new Error("endpoint configuration required");
    if (this._config.token !== null && (this._token = this._config.token), this._config.data !== null && (this._data = this._config.data), this._codec = new Ht(), this._formatOverride(), (this._config.debug === !0 || typeof localStorage < "u" && localStorage.getItem("centrifuge.debug")) && (this._debugEnabled = !0), this._debug("config", this._config), typeof this._endpoint != "string") if (typeof this._endpoint == "object" && this._endpoint instanceof Array) {
      this._transports = this._endpoint, this._emulation = !0;
      for (const e in this._transports)
        if (this._transports.hasOwnProperty(e)) {
          const t = this._transports[e];
          if (!t.endpoint || !t.transport)
            throw new Error("malformed transport configuration");
          const n = t.transport;
          if (["websocket", "http_stream", "sse", "sockjs", "webtransport"].indexOf(n) < 0)
            throw new Error("unsupported transport name: " + n);
        }
    } else
      throw new Error("unsupported url configuration type: only string or array of objects are supported");
  }
  _setState(e) {
    if (this.state !== e) {
      this._reconnecting = !1;
      const t = this.state;
      return this.state = e, this.emit("state", { newState: e, oldState: t }), !0;
    }
    return !1;
  }
  _isDisconnected() {
    return this.state === O.Disconnected;
  }
  _isConnecting() {
    return this.state === O.Connecting;
  }
  _isConnected() {
    return this.state === O.Connected;
  }
  _nextCommandId() {
    return ++this._commandId;
  }
  _setNetworkEvents() {
    if (this._networkEventsSet)
      return;
    let e = null;
    this._config.networkEventTarget !== null ? e = this._config.networkEventTarget : typeof globalThis.addEventListener < "u" && (e = globalThis), e && (e.addEventListener("offline", () => {
      this._debug("offline event triggered"), (this.state === O.Connected || this.state === O.Connecting) && (this._disconnect(ne.transportClosed, "transport closed", !0), this._deviceWentOffline = !0);
    }), e.addEventListener("online", () => {
      this._debug("online event triggered"), this.state === O.Connecting && (this._deviceWentOffline && !this._transportClosed && (this._deviceWentOffline = !1, this._transportClosed = !0), this._clearReconnectTimeout(), this._startReconnecting());
    }), this._networkEventsSet = !0);
  }
  _getReconnectDelay() {
    const e = Be(this._reconnectAttempts, this._config.minReconnectDelay, this._config.maxReconnectDelay);
    return this._reconnectAttempts += 1, e;
  }
  _clearOutgoingRequests() {
    for (const e in this._callbacks)
      if (this._callbacks.hasOwnProperty(e)) {
        const t = this._callbacks[e];
        clearTimeout(t.timeout);
        const n = t.errback;
        if (!n)
          continue;
        n({ error: this._createErrorObject(C.connectionClosed, "connection closed") });
      }
    this._callbacks = {};
  }
  _clearConnectedState() {
    this._client = null, this._clearServerPingTimeout(), this._clearRefreshTimeout();
    for (const e in this._subs) {
      if (!this._subs.hasOwnProperty(e))
        continue;
      const t = this._subs[e];
      t.state === U.Subscribed && t._setSubscribing(He.transportClosed, "transport closed");
    }
    for (const e in this._serverSubs)
      this._serverSubs.hasOwnProperty(e) && this.emit("subscribing", { channel: e });
  }
  _handleWriteError(e) {
    for (const t of e) {
      const n = t.id;
      if (!(n in this._callbacks))
        continue;
      const s = this._callbacks[n];
      clearTimeout(this._callbacks[n].timeout), delete this._callbacks[n];
      const r = s.errback;
      r({ error: this._createErrorObject(C.transportWriteError, "transport write error") });
    }
  }
  _transportSendCommands(e) {
    if (!e.length)
      return !0;
    if (!this._transport)
      return !1;
    try {
      this._transport.send(this._codec.encodeCommands(e), this._session, this._node);
    } catch (t) {
      return this._debug("error writing commands", t), this._handleWriteError(e), !1;
    }
    return !0;
  }
  _initializeTransport() {
    let e;
    this._config.websocket !== null ? e = this._config.websocket : typeof globalThis.WebSocket != "function" && typeof globalThis.WebSocket != "object" || (e = globalThis.WebSocket);
    let t = null;
    this._config.sockjs !== null ? t = this._config.sockjs : typeof globalThis.SockJS < "u" && (t = globalThis.SockJS);
    let n = null;
    this._config.eventsource !== null ? n = this._config.eventsource : typeof globalThis.EventSource < "u" && (n = globalThis.EventSource);
    let s = null;
    this._config.fetch !== null ? s = this._config.fetch : typeof globalThis.fetch < "u" && (s = globalThis.fetch);
    let r = null;
    if (this._config.readableStream !== null ? r = this._config.readableStream : typeof globalThis.ReadableStream < "u" && (r = globalThis.ReadableStream), this._emulation) {
      this._currentTransportIndex >= this._transports.length && (this._triedAllTransports = !0, this._currentTransportIndex = 0);
      let y = 0;
      for (; ; ) {
        if (y >= this._transports.length)
          throw new Error("no supported transport found");
        const I = this._transports[this._currentTransportIndex], T = I.transport, E = I.endpoint;
        if (T === "websocket") {
          if (this._debug("trying websocket transport"), this._transport = new Wt(E, {
            websocket: e
          }), !this._transport.supported()) {
            this._debug("websocket transport not available"), this._currentTransportIndex++, y++;
            continue;
          }
        } else if (T === "webtransport") {
          if (this._debug("trying webtransport transport"), this._transport = new Vn(E, {
            webtransport: globalThis.WebTransport,
            decoder: this._codec,
            encoder: this._codec
          }), !this._transport.supported()) {
            this._debug("webtransport transport not available"), this._currentTransportIndex++, y++;
            continue;
          }
        } else if (T === "http_stream") {
          if (this._debug("trying http_stream transport"), this._transport = new Bn(E, {
            fetch: s,
            readableStream: r,
            emulationEndpoint: this._config.emulationEndpoint,
            decoder: this._codec,
            encoder: this._codec
          }), !this._transport.supported()) {
            this._debug("http_stream transport not available"), this._currentTransportIndex++, y++;
            continue;
          }
        } else if (T === "sse") {
          if (this._debug("trying sse transport"), this._transport = new Fn(E, {
            eventsource: n,
            fetch: s,
            emulationEndpoint: this._config.emulationEndpoint
          }), !this._transport.supported()) {
            this._debug("sse transport not available"), this._currentTransportIndex++, y++;
            continue;
          }
        } else if (T === "sockjs") {
          if (this._debug("trying sockjs"), this._transport = new qn(E, {
            sockjs: t,
            sockjsOptions: this._config.sockjsOptions
          }), !this._transport.supported()) {
            this._debug("sockjs transport not available"), this._currentTransportIndex++, y++;
            continue;
          }
        } else
          throw new Error("unknown transport " + T);
        break;
      }
    } else {
      if (zn(this._endpoint, "http"))
        throw new Error("Provide explicit transport endpoints configuration in case of using HTTP (i.e. using array of TransportEndpoint instead of a single string), or use ws(s):// scheme in an endpoint if you aimed using WebSocket transport");
      if (this._debug("client will use websocket"), this._transport = new Wt(this._endpoint, {
        websocket: e
      }), !this._transport.supported())
        throw new Error("WebSocket constructor not found, make sure it is available globally or passed as a dependency in Centrifuge options");
    }
    const o = this, f = this._transport, c = this._nextTransportId();
    o._debug("id of transport", c);
    let _ = !1;
    const v = [];
    if (this._transport.emulation()) {
      const y = o._sendConnect(!0);
      v.push(y);
    }
    this._setNetworkEvents();
    const x = this._codec.encodeCommands(v);
    this._transportClosed = !1;
    let P;
    P = setTimeout(function() {
      f.close();
    }, this._config.timeout), this._transport.initialize(this._codec.name(), {
      onOpen: function() {
        if (P && (clearTimeout(P), P = null), o._transportId != c) {
          o._debug("open callback from non-actual transport"), f.close();
          return;
        }
        _ = !0, o._debug(f.subName(), "transport open"), !f.emulation() && (o._transportIsOpen = !0, o._transportWasOpen = !0, o.startBatching(), o._sendConnect(!1), o._sendSubscribeCommands(), o.stopBatching(), o.emit("__centrifuge_debug:connect_frame_sent", {}));
      },
      onError: function(y) {
        if (o._transportId != c) {
          o._debug("error callback from non-actual transport");
          return;
        }
        o._debug("transport level error", y);
      },
      onClose: function(y) {
        if (P && (clearTimeout(P), P = null), o._transportId != c) {
          o._debug("close callback from non-actual transport");
          return;
        }
        o._debug(f.subName(), "transport closed"), o._transportClosed = !0, o._transportIsOpen = !1;
        let I = "connection closed", T = !0, E = 0;
        if (y && "code" in y && y.code && (E = y.code), y && y.reason)
          try {
            const q = JSON.parse(y.reason);
            I = q.reason, T = q.reconnect;
          } catch {
            I = y.reason, (E >= 3500 && E < 4e3 || E >= 4500 && E < 5e3) && (T = !1);
          }
        E < 3e3 ? (E === 1009 ? (E = xe.messageSizeLimit, I = "message size limit exceeded", T = !1) : (E = ne.transportClosed, I = "transport closed"), o._emulation && !o._transportWasOpen && (o._currentTransportIndex++, o._currentTransportIndex >= o._transports.length && (o._triedAllTransports = !0, o._currentTransportIndex = 0))) : o._transportWasOpen = !0, o._isConnecting() && !_ && o.emit("error", {
          type: "transport",
          error: {
            code: C.transportClosed,
            message: "transport closed"
          },
          transport: f.name()
        }), o._reconnecting = !1, o._disconnect(E, I, T);
      },
      onMessage: function(y) {
        o._dataReceived(y);
      }
    }, x), o.emit("__centrifuge_debug:transport_initialized", {});
  }
  _sendConnect(e) {
    const t = this._constructConnectCommand(), n = this;
    return this._call(t, e).then((s) => {
      const r = s.reply.connect;
      n._connectResponse(r), s.next && s.next();
    }, (s) => {
      n._connectError(s.error), s.next && s.next();
    }), t;
  }
  _startReconnecting() {
    if (this._debug("start reconnecting"), !this._isConnecting()) {
      this._debug("stop reconnecting: client not in connecting state");
      return;
    }
    if (this._reconnecting) {
      this._debug("reconnect already in progress, return from reconnect routine");
      return;
    }
    if (this._transportClosed === !1) {
      this._debug("waiting for transport close");
      return;
    }
    this._reconnecting = !0;
    const e = this._token === "";
    if (!(this._refreshRequired || e && this._config.getToken !== null)) {
      this._config.getData ? this._config.getData().then((s) => {
        this._isConnecting() && (this._data = s, this._initializeTransport());
      }).catch((s) => this._handleGetDataError(s)) : this._initializeTransport();
      return;
    }
    const n = this;
    this._getToken().then(function(s) {
      if (n._isConnecting()) {
        if (s == null || s == null) {
          n._failUnauthorized();
          return;
        }
        n._token = s, n._debug("connection token refreshed"), n._config.getData ? n._config.getData().then(function(r) {
          n._isConnecting() && (n._data = r, n._initializeTransport());
        }).catch((r) => n._handleGetDataError(r)) : n._initializeTransport();
      }
    }).catch(function(s) {
      if (!n._isConnecting())
        return;
      if (s instanceof Y) {
        n._failUnauthorized();
        return;
      }
      n.emit("error", {
        type: "connectToken",
        error: {
          code: C.clientConnectToken,
          message: s !== void 0 ? s.toString() : ""
        }
      });
      const r = n._getReconnectDelay();
      n._debug("error on getting connection token, reconnect after " + r + " milliseconds", s), n._reconnecting = !1, n._reconnectTimeout = setTimeout(() => {
        n._startReconnecting();
      }, r);
    });
  }
  _handleGetDataError(e) {
    if (e instanceof Y) {
      this._failUnauthorized();
      return;
    }
    this.emit("error", {
      type: "connectData",
      error: {
        code: C.badConfiguration,
        message: e?.toString() || ""
      }
    });
    const t = this._getReconnectDelay();
    this._debug("error on getting connect data, reconnect after " + t + " milliseconds", e), this._reconnecting = !1, this._reconnectTimeout = setTimeout(() => {
      this._startReconnecting();
    }, t);
  }
  _connectError(e) {
    this.state === O.Connecting && (e.code === 109 && (this._refreshRequired = !0), e.code < 100 || e.temporary === !0 || e.code === 109 ? (this.emit("error", {
      type: "connect",
      error: e
    }), this._debug("closing transport due to connect error"), this._disconnect(e.code, e.message, !0)) : this._disconnect(e.code, e.message, !1));
  }
  _scheduleReconnect() {
    if (!this._isConnecting())
      return;
    let e = !1;
    this._emulation && !this._transportWasOpen && !this._triedAllTransports && (e = !0);
    let t = this._getReconnectDelay();
    e && (t = 0), this._debug("reconnect after " + t + " milliseconds"), this._clearReconnectTimeout(), this._reconnectTimeout = setTimeout(() => {
      this._startReconnecting();
    }, t);
  }
  _constructConnectCommand() {
    const e = {};
    this._token && (e.token = this._token), this._data && (e.data = this._data), this._config.name && (e.name = this._config.name), this._config.version && (e.version = this._config.version), Object.keys(this._config.headers).length > 0 && (e.headers = this._config.headers);
    const t = {};
    let n = !1;
    for (const s in this._serverSubs)
      if (this._serverSubs.hasOwnProperty(s) && this._serverSubs[s].recoverable) {
        n = !0;
        const r = {
          recover: !0
        };
        this._serverSubs[s].offset && (r.offset = this._serverSubs[s].offset), this._serverSubs[s].epoch && (r.epoch = this._serverSubs[s].epoch), t[s] = r;
      }
    return n && (e.subs = t), {
      connect: e
    };
  }
  _getHistoryRequest(e, t) {
    const n = {
      channel: e
    };
    return t !== void 0 && (t.since && (n.since = {
      offset: t.since.offset
    }, t.since.epoch && (n.since.epoch = t.since.epoch)), t.limit !== void 0 && (n.limit = t.limit), t.reverse === !0 && (n.reverse = !0)), n;
  }
  _methodCall() {
    return this._isConnected() ? Promise.resolve() : new Promise((e, t) => {
      const n = setTimeout(function() {
        t({ code: C.timeout, message: "timeout" });
      }, this._config.timeout);
      this._promises[this._nextPromiseId()] = {
        timeout: n,
        resolve: e,
        reject: t
      };
    });
  }
  _callPromise(e, t) {
    return new Promise((n, s) => {
      this._call(e, !1).then((r) => {
        n(t(r.reply)), r.next && r.next();
      }, (r) => {
        s(r.error), r.next && r.next();
      });
    });
  }
  _dataReceived(e) {
    this._serverPing > 0 && this._waitServerPing();
    const t = this._codec.decodeReplies(e);
    this._dispatchPromise = this._dispatchPromise.then(() => {
      let n;
      this._dispatchPromise = new Promise((s) => {
        n = s;
      }), this._dispatchSynchronized(t, n);
    });
  }
  _dispatchSynchronized(e, t) {
    let n = Promise.resolve();
    for (const s in e)
      e.hasOwnProperty(s) && (n = n.then(() => this._dispatchReply(e[s])));
    n = n.then(() => {
      t();
    });
  }
  _dispatchReply(e) {
    let t;
    const n = new Promise((r) => {
      t = r;
    });
    if (e == null)
      return this._debug("dispatch: got undefined or null reply"), t(), n;
    const s = e.id;
    return s && s > 0 ? this._handleReply(e, t) : e.push ? this._handlePush(e.push, t) : this._handleServerPing(t), n;
  }
  _call(e, t) {
    return new Promise((n, s) => {
      e.id = this._nextCommandId(), this._registerCall(e.id, n, s), t || this._addCommand(e);
    });
  }
  _startConnecting() {
    this._debug("start connecting"), this._setState(O.Connecting) && this.emit("connecting", { code: ne.connectCalled, reason: "connect called" }), this._client = null, this._startReconnecting();
  }
  _disconnect(e, t, n) {
    if (this._isDisconnected())
      return;
    this._transportIsOpen = !1;
    const s = this.state;
    this._reconnecting = !1;
    const r = {
      code: e,
      reason: t
    };
    let o = !1;
    if (n ? o = this._setState(O.Connecting) : (o = this._setState(O.Disconnected), this._rejectPromises({ code: C.clientDisconnected, message: "disconnected" })), this._clearOutgoingRequests(), s === O.Connecting && this._clearReconnectTimeout(), s === O.Connected && this._clearConnectedState(), o && (this._isConnecting() ? this.emit("connecting", r) : this.emit("disconnected", r)), this._transport) {
      this._debug("closing existing transport");
      const f = this._transport;
      this._transport = null, f.close(), this._transportClosed = !0, this._nextTransportId();
    } else
      this._debug("no transport to close");
    this._scheduleReconnect();
  }
  _failUnauthorized() {
    this._disconnect(xe.unauthorized, "unauthorized", !1);
  }
  _getToken() {
    if (this._debug("get connection token"), !this._config.getToken)
      throw this.emit("error", {
        type: "configuration",
        error: {
          code: C.badConfiguration,
          message: "token expired but no getToken function set in the configuration"
        }
      }), new Y("");
    return this._config.getToken({});
  }
  _refresh() {
    const e = this._client, t = this;
    this._getToken().then(function(n) {
      if (e !== t._client)
        return;
      if (!n) {
        t._failUnauthorized();
        return;
      }
      if (t._token = n, t._debug("connection token refreshed"), !t._isConnected())
        return;
      const s = {
        refresh: { token: t._token }
      };
      t._call(s, !1).then((r) => {
        const o = r.reply.refresh;
        t._refreshResponse(o), r.next && r.next();
      }, (r) => {
        t._refreshError(r.error), r.next && r.next();
      });
    }).catch(function(n) {
      if (t._isConnected()) {
        if (n instanceof Y) {
          t._failUnauthorized();
          return;
        }
        t.emit("error", {
          type: "refreshToken",
          error: {
            code: C.clientRefreshToken,
            message: n !== void 0 ? n.toString() : ""
          }
        }), t._refreshTimeout = setTimeout(() => t._refresh(), t._getRefreshRetryDelay());
      }
    });
  }
  _refreshError(e) {
    e.code < 100 || e.temporary === !0 ? (this.emit("error", {
      type: "refresh",
      error: e
    }), this._refreshTimeout = setTimeout(() => this._refresh(), this._getRefreshRetryDelay())) : this._disconnect(e.code, e.message, !1);
  }
  _getRefreshRetryDelay() {
    return Be(0, 5e3, 1e4);
  }
  _refreshResponse(e) {
    this._refreshTimeout && (clearTimeout(this._refreshTimeout), this._refreshTimeout = null), e.expires && (this._client = e.client, this._refreshTimeout = setTimeout(() => this._refresh(), Fe(e.ttl)));
  }
  _removeSubscription(e) {
    e !== null && delete this._subs[e.channel];
  }
  _unsubscribe(e) {
    if (!this._transportIsOpen)
      return Promise.resolve();
    const n = { unsubscribe: {
      channel: e.channel
    } }, s = this;
    return new Promise((o, f) => {
      this._call(n, !1).then((c) => {
        o(), c.next && c.next();
      }, (c) => {
        o(), c.next && c.next(), s._disconnect(ne.unsubscribeError, "unsubscribe error", !0);
      });
    });
  }
  _getSub(e) {
    const t = this._subs[e];
    return t || null;
  }
  _isServerSub(e) {
    return this._serverSubs[e] !== void 0;
  }
  _sendSubscribeCommands() {
    const e = [];
    for (const t in this._subs) {
      if (!this._subs.hasOwnProperty(t))
        continue;
      const n = this._subs[t];
      if (n._inflight !== !0 && n.state === U.Subscribing) {
        const s = n._subscribe();
        s && e.push(s);
      }
    }
    return e;
  }
  _connectResponse(e) {
    if (this._transportIsOpen = !0, this._transportWasOpen = !0, this._reconnectAttempts = 0, this._refreshRequired = !1, this._isConnected())
      return;
    this._client = e.client, this._setState(O.Connected), this._refreshTimeout && clearTimeout(this._refreshTimeout), e.expires && (this._refreshTimeout = setTimeout(() => this._refresh(), Fe(e.ttl))), this._session = e.session, this._node = e.node, this.startBatching(), this._sendSubscribeCommands(), this.stopBatching();
    const t = {
      client: e.client,
      transport: this._transport.subName()
    };
    e.data && (t.data = e.data), this.emit("connected", t), this._resolvePromises(), this._processServerSubs(e.subs || {}), e.ping && e.ping > 0 ? (this._serverPing = e.ping * 1e3, this._sendPong = e.pong === !0, this._waitServerPing()) : this._serverPing = 0;
  }
  _processServerSubs(e) {
    for (const t in e) {
      if (!e.hasOwnProperty(t))
        continue;
      const n = e[t];
      this._serverSubs[t] = {
        offset: n.offset,
        epoch: n.epoch,
        recoverable: n.recoverable || !1
      };
      const s = this._getSubscribeContext(t, n);
      this.emit("subscribed", s);
    }
    for (const t in e) {
      if (!e.hasOwnProperty(t))
        continue;
      const n = e[t];
      if (n.recovered) {
        const s = n.publications;
        if (s && s.length > 0)
          for (const r in s)
            s.hasOwnProperty(r) && this._handlePublication(t, s[r]);
      }
    }
    for (const t in this._serverSubs)
      this._serverSubs.hasOwnProperty(t) && (e[t] || (this.emit("unsubscribed", { channel: t }), delete this._serverSubs[t]));
  }
  _clearRefreshTimeout() {
    this._refreshTimeout !== null && (clearTimeout(this._refreshTimeout), this._refreshTimeout = null);
  }
  _clearReconnectTimeout() {
    this._reconnectTimeout !== null && (clearTimeout(this._reconnectTimeout), this._reconnectTimeout = null);
  }
  _clearServerPingTimeout() {
    this._serverPingTimeout !== null && (clearTimeout(this._serverPingTimeout), this._serverPingTimeout = null);
  }
  _waitServerPing() {
    this._config.maxServerPingDelay !== 0 && this._isConnected() && (this._clearServerPingTimeout(), this._serverPingTimeout = setTimeout(() => {
      this._isConnected() && this._disconnect(ne.noPing, "no ping", !0);
    }, this._serverPing + this._config.maxServerPingDelay));
  }
  _getSubscribeContext(e, t) {
    const n = {
      channel: e,
      positioned: !1,
      recoverable: !1,
      wasRecovering: !1,
      recovered: !1
    };
    t.recovered && (n.recovered = !0), t.positioned && (n.positioned = !0), t.recoverable && (n.recoverable = !0), t.was_recovering && (n.wasRecovering = !0);
    let s = "";
    "epoch" in t && (s = t.epoch);
    let r = 0;
    return "offset" in t && (r = t.offset), (n.positioned || n.recoverable) && (n.streamPosition = {
      offset: r,
      epoch: s
    }), t.data && (n.data = t.data), n;
  }
  _handleReply(e, t) {
    const n = e.id;
    if (!(n in this._callbacks)) {
      t();
      return;
    }
    const s = this._callbacks[n];
    if (clearTimeout(this._callbacks[n].timeout), delete this._callbacks[n], Wn(e)) {
      const r = s.errback;
      if (!r) {
        t();
        return;
      }
      const o = e.error;
      r({ error: o, next: t });
    } else {
      const r = s.callback;
      if (!r)
        return;
      r({ reply: e, next: t });
    }
  }
  _handleJoin(e, t) {
    const n = this._getSub(e);
    if (!n) {
      if (this._isServerSub(e)) {
        const s = { channel: e, info: this._getJoinLeaveContext(t.info) };
        this.emit("join", s);
      }
      return;
    }
    n._handleJoin(t);
  }
  _handleLeave(e, t) {
    const n = this._getSub(e);
    if (!n) {
      if (this._isServerSub(e)) {
        const s = { channel: e, info: this._getJoinLeaveContext(t.info) };
        this.emit("leave", s);
      }
      return;
    }
    n._handleLeave(t);
  }
  _handleUnsubscribe(e, t) {
    const n = this._getSub(e);
    if (!n) {
      this._isServerSub(e) && (delete this._serverSubs[e], this.emit("unsubscribed", { channel: e }));
      return;
    }
    t.code < 2500 ? n._setUnsubscribed(t.code, t.reason, !1) : n._setSubscribing(t.code, t.reason);
  }
  _handleSubscribe(e, t) {
    this._serverSubs[e] = {
      offset: t.offset,
      epoch: t.epoch,
      recoverable: t.recoverable || !1
    }, this.emit("subscribed", this._getSubscribeContext(e, t));
  }
  _handleDisconnect(e) {
    const t = e.code;
    let n = !0;
    (t >= 3500 && t < 4e3 || t >= 4500 && t < 5e3) && (n = !1), this._disconnect(t, e.reason, n);
  }
  _getPublicationContext(e, t) {
    const n = {
      channel: e,
      data: t.data
    };
    return t.offset && (n.offset = t.offset), t.info && (n.info = this._getJoinLeaveContext(t.info)), t.tags && (n.tags = t.tags), n;
  }
  _getJoinLeaveContext(e) {
    const t = {
      client: e.client,
      user: e.user
    };
    return e.conn_info && (t.connInfo = e.conn_info), e.chan_info && (t.chanInfo = e.chan_info), t;
  }
  _handlePublication(e, t) {
    const n = this._getSub(e);
    if (!n) {
      if (this._isServerSub(e)) {
        const s = this._getPublicationContext(e, t);
        this.emit("publication", s), t.offset !== void 0 && (this._serverSubs[e].offset = t.offset);
      }
      return;
    }
    n._handlePublication(t);
  }
  _handleMessage(e) {
    this.emit("message", { data: e.data });
  }
  _handleServerPing(e) {
    if (this._sendPong) {
      const t = {};
      this._transportSendCommands([t]);
    }
    e();
  }
  _handlePush(e, t) {
    const n = e.channel;
    e.pub ? this._handlePublication(n, e.pub) : e.message ? this._handleMessage(e.message) : e.join ? this._handleJoin(n, e.join) : e.leave ? this._handleLeave(n, e.leave) : e.unsubscribe ? this._handleUnsubscribe(n, e.unsubscribe) : e.subscribe ? this._handleSubscribe(n, e.subscribe) : e.disconnect && this._handleDisconnect(e.disconnect), t();
  }
  _flush() {
    const e = this._commands.slice(0);
    this._commands = [], this._transportSendCommands(e);
  }
  _createErrorObject(e, t, n) {
    const s = {
      code: e,
      message: t
    };
    return n && (s.temporary = !0), s;
  }
  _registerCall(e, t, n) {
    this._callbacks[e] = {
      callback: t,
      errback: n,
      timeout: null
    }, this._callbacks[e].timeout = setTimeout(() => {
      delete this._callbacks[e], en(n) && n({ error: this._createErrorObject(C.timeout, "timeout") });
    }, this._config.timeout);
  }
  _addCommand(e) {
    this._batching ? this._commands.push(e) : this._transportSendCommands([e]);
  }
  _nextPromiseId() {
    return ++this._promiseId;
  }
  _nextTransportId() {
    return ++this._transportId;
  }
  _resolvePromises() {
    for (const e in this._promises)
      this._promises.hasOwnProperty(e) && (this._promises[e].timeout && clearTimeout(this._promises[e].timeout), this._promises[e].resolve(), delete this._promises[e]);
  }
  _rejectPromises(e) {
    for (const t in this._promises)
      this._promises.hasOwnProperty(t) && (this._promises[t].timeout && clearTimeout(this._promises[t].timeout), this._promises[t].reject(e), delete this._promises[t]);
  }
}
Ge.SubscriptionState = U;
Ge.State = O;
Ge.UnauthorizedError = Y;
function Zn() {
  if (p("Detecting WebSocket constructor..."), typeof window < "u" && window.WebSocket)
    return p("Using browser WebSocket constructor"), window.WebSocket;
  if (typeof global < "u")
    try {
      const i = require("ws");
      return p("Using Node.js ws package WebSocket constructor"), i.WebSocket;
    } catch (i) {
      if (p("ws package not available, trying global WebSocket", i), global.WebSocket)
        return p("Using Node.js global WebSocket constructor"), global.WebSocket;
      throw new Error(
        'WebSocket not available. Please install "ws" package for Node.js environments or use Node.js 18+.'
      );
    }
  throw new Error("WebSocket not available in this environment.");
}
function Qn(i) {
  let e = null;
  return p("Creating connection manager with config:", i), {
    connect() {
      if (p("Attempting to connect..."), e) {
        p("Already connected, skipping");
        return;
      }
      const { initData: n, apiUrl: s, ...r } = i;
      p("Connection config:", { apiUrl: s, centrifugoConfig: r });
      try {
        const o = Zn();
        p("WebSocket constructor obtained successfully"), e = new Ge(s, {
          ...r,
          websocket: o
        }), p("Centrifuge instance created successfully");
      } catch (o) {
        throw p("Failed to create Centrifuge instance:", o), o;
      }
      e.on("error", (o) => {
        p("Centrifuge error event:", o);
      }), e.on("connected", () => {
        p("Centrifuge connected successfully");
      }), e.on("disconnected", () => {
        p("Centrifuge disconnected");
      }), e.on("connecting", () => {
        p("Centrifuge connecting...");
      }), p("Initiating connection..."), e.connect();
    },
    disconnect() {
      p("Disconnecting..."), e ? (e.disconnect(), e = null, p("Disconnected successfully")) : p("No active connection to disconnect");
    },
    publish(n, s) {
      if (p(`Publishing to channel: ${n}`, { data: s }), !e)
        throw p("Cannot publish: not connected to Centrifugo"), new Error("Not connected to Centrifugo");
      try {
        e.publish(n, s), p(`Published successfully to channel: ${n}`);
      } catch (r) {
        throw p(`Failed to publish to channel: ${n}`, { error: r }), r;
      }
    },
    once(n, s) {
      if (p(`Setting up once event listener for: ${n}`), !e)
        throw p("Cannot set up event listener: not connected to Centrifugo"), new Error("Not connected to Centrifugo");
      e.once(n, s), p(`Event listener set up successfully for: ${n}`);
    },
    isConnected() {
      const n = e?.state === "connected";
      return p(`Connection status check: ${n}`, { state: e?.state }), n;
    }
    // async subscribe(channel: string) {
    //   if (!centrifuge) {
    //     throw new Error('Not connected to Centrifugo')
    //   }
    //   const subscription = centrifuge.newSubscription(channel)
    //   await subscription.subscribe()
    // },
    // unsubscribe(channel: string) {
    //   if (!centrifuge) {
    //     return
    //   }
    //   const subscription = centrifuge.getSubscription(channel)
    //   if (subscription) {
    //     subscription.unsubscribe()
    //   }
    // },
  };
}
function ei() {
  let i = null, e = null, t = null, n = null, s = null, r = null, o = !1, f = Date.now(), c = !1;
  p("Creating EwaAnalytics SDK instance");
  function _(w) {
    return new tn({
      baseURL: w.apiUrl,
      headers: {
        Accept: "application/json",
        "X-Platform-Id": "255c5893-e2a4-4860-83d8-c2e30433e9f6",
        "X-Requested-With": "XMLHttpRequest"
      }
    });
  }
  function v(w) {
    if (!o)
      throw new Error(
        `SDK not initialized ${w ? `during ${w}` : ""}. Call init() first.`
      );
  }
  function x(w) {
    return w || r || void 0;
  }
  function P(w) {
    const D = {
      transport: w.transport,
      apiUrl: w.apiUrl,
      randomUserId: w.initData.randomUserId,
      ip_address: w.initData.ip_address,
      environment: w.initData.environment
    }, W = Object.entries(D).filter(([H, Je]) => !Je).map(([H]) => H);
    if (W.length > 0)
      throw new Error(`Missing required config options: [${W.join(", ")}] are required`);
  }
  function y() {
    c ? (o = !0, p("SDK initialization completed successfully - internal events sent")) : p("SDK initialization pending - waiting for internal events");
  }
  async function I() {
    if (e)
      if (e.transport === "websocket")
        i = Qn(e), p("Starting WebSocket connection..."), i.connect();
      else if (e.transport === "http")
        t = _(e), p("HTTP transport initialized");
      else
        throw new Error(`Invalid transport: ${e.transport}. Must be 'websocket' or 'http'`);
  }
  async function T() {
    e && (n = new Rn({
      globalConfig: e,
      connection: i,
      apiInstance: t,
      sessionId: f
    }), s = new pn({
      eventTracker: n,
      globalConfig: e,
      connection: i
    }));
  }
  async function E() {
    if (!e || !s) return;
    e.autoSendInternalEvents !== !1 ? (p("Auto-sending internal events during initialization"), await Z.sendInternalEvents(e.initData, x(r))) : p("Auto-sending internal events disabled. Manual sending required.");
  }
  function q() {
    if (!n)
      throw new Error("Event tracker not available");
    return n;
  }
  const Z = {
    async init(w) {
      p("Starting SDK initialization with config:", w);
      try {
        r = w.context || null, e = w, P(e), await I(), await T(), await E(), y();
      } catch (D) {
        throw p("Error during SDK initialization:", D), o = !1, D;
      }
    },
    async sendInternalEvents(w, D) {
      if (!s)
        throw new Error("Internal events not available");
      const W = x(D);
      try {
        await s.sendSessionStarted(W), await s.sendSessionLocated(w.country, w.ip_address, W), c = !0, p("Internal events sent successfully"), y();
      } catch (H) {
        throw p("Error sending internal events:", H), H;
      }
    },
    async trackEvent(w, D, W) {
      v(D.event_name);
      const H = q(), Je = x(W);
      try {
        await H.trackEvent(w, D, Je), p(`Event tracked successfully: ${w}`);
      } catch (wt) {
        throw p(`Error tracking event (${w}):`, wt), wt;
      }
    },
    async trackSession(w, D) {
      v(), q();
      const W = x(D);
      try {
        await n.trackSessionTyped(w, W), p("Session tracked successfully");
      } catch (H) {
        throw p("Error tracking session:", H), H;
      }
    },
    async trackEventTyped(w, D) {
      v(), q();
      const W = x(D);
      try {
        await n.trackEventTyped(w, W), p("Typed event tracked successfully");
      } catch (H) {
        throw p("Error tracking typed event:", H), H;
      }
    },
    async sendSessionAttributed(w, D) {
      if (!e)
        throw new Error("Config not available");
      if (!w) {
        p("Web UUID is not set. Session attributed event not sent", w, "error");
        return;
      }
      q();
      const W = {
        event_name: "session",
        event_subtype: Ne.ATTRIBUTED,
        random_user_id: e.initData.randomUserId,
        app_id: e.initData.appId || "web",
        web_uuid: w,
        platform: e.initData.platform || "web"
        // environment: 'sandbox', // TODO: make configurable
      };
      await n.trackEvent("session", W, D), p("Session attribution sent successfully");
    },
    getConnection() {
      if (v(), e?.transport === "http")
        return p("HTTP transport - no active socket connections"), null;
      if (e?.transport === "websocket")
        return p("Getting WebSocket connection instance"), i;
      throw new Error("Invalid transport configuration");
    },
    isInitialized() {
      return o;
    },
    getConfig() {
      return e;
    },
    updateContext(w) {
      r = w, p("Context updated:", w);
    },
    clearContext() {
      r = null, p("Context cleared");
    },
    areInternalEventsSent() {
      return c;
    }
  };
  return Z;
}
export {
  je as DeviceTypes,
  fn as EwaAnalyticsChannels,
  Ne as EwaSessionSubtype,
  oe as OsTypes,
  ei as createEwaAnalyticsSdk
};
//# sourceMappingURL=index.es.js.map
